import video from "../assets/videos/deconstructed3.mp4";
import bloomCover from "../assets/images/BloomCover.jpg";
import ateliermain from "../assets/images/ateliermain.jpg";
import igormain from "../assets/images/igormain.jpg";
import igormain2 from "../assets/images/igormain2.jpg";
import nine from "../assets/images/9.png";
import ten from "../assets/images/10.jpg";
import eleven from "../assets/images/11.jpg";
import twelve from "../assets/images/12.jpg";
import therteen from "../assets/images/13.jpg";
import fourteen from "../assets/images/14.jpg";
import fifteen from "../assets/images/15.png";
import sixteen from "../assets/images/16.png";
import sg1 from "../assets/images/sg1.jpg";
import sg2 from "../assets/images/sg2.jpg";
import sg3 from "../assets/images/sg3.JPG";
import sg4 from "../assets/images/sg4.jpg";
import sg5 from "../assets/images/sg5.jpg";
import sg6 from "../assets/images/sg6.jpg";
import sg7 from "../assets/images/sg7.jpg";
import sg8 from "../assets/images/sg8.jpg";
import sg9 from "../assets/images/sg9.jpg";
import sg10 from "../assets/images/sg10.jpg";
import sg13 from "../assets/images/sg13.jpg";
import sg15 from "../assets/images/sg15.jpg";
import sg16 from "../assets/images/sg16.jpg";
import sg21 from "../assets/images/sg21.jpg";
import sg22 from "../assets/images/sg22.jpg";
import sg26 from "../assets/images/sg26.jpg";
import sg27 from "../assets/images/sg27.jpg";
import sg28 from "../assets/images/sg28.jpg";
import sg29 from "../assets/images/sg29.jpg";
import sg30 from "../assets/images/sg30.jpg";
import afHome1 from "../assets/images/afHome1.jpg";
import afHome2 from "../assets/images/afHome2.jpg";
import af1 from "../assets/images/af1.jpg";
import af2 from "../assets/images/af2.jpg";
import af3 from "../assets/images/af3.jpg";
import af4 from "../assets/images/af4.jpg";
import af5 from "../assets/images/af5.jpg";
import af6 from "../assets/images/af6.jpg";
import af7 from "../assets/images/af7.jpg";
import af8 from "../assets/images/af8.jpg";
import af9 from "../assets/images/af9.jpg";
import af10 from "../assets/images/af10.jpg";
import af11 from "../assets/images/af11.jpg";
import af12 from "../assets/images/af12.jpg";
import af13 from "../assets/images/af13.jpg";
import af14 from "../assets/images/af14.jpg";
import af15 from "../assets/images/af15.jpg";
import af16 from "../assets/images/af16.jpg";
import af17 from "../assets/images/af17.jpg";
import af18 from "../assets/images/af18.jpg";
import af19 from "../assets/images/af19.jpg";
import af20 from "../assets/images/af20.jpg";
import af21 from "../assets/images/af21.jpg";
import af22 from "../assets/images/af22.jpg";
import af23 from "../assets/images/af23.jpg";
import af24 from "../assets/images/af24.jpg";
import af25 from "../assets/images/af25.jpg";
import af26 from "../assets/images/af26.jpg";
import af27 from "../assets/images/af27.jpg";
import af28 from "../assets/images/af28.jpg";
import af29 from "../assets/images/af29.jpg";
import lbd1 from "../assets/images/lbd1.jpg";
import lbd2 from "../assets/images/lbd2.jpg";
import lbd3 from "../assets/images/lbd3.jpg";
import lbd4 from "../assets/images/lbd4.jpg";
import lbd5 from "../assets/images/lbd5.jpg";
import lbd6 from "../assets/images/lbd6.jpg";
import lbd7 from "../assets/images/lbd7.jpg";
import lbd8 from "../assets/images/lbd8.jpg";
import lbd9 from "../assets/images/lbd9.jpg";
import lbd10 from "../assets/images/lbd10.jpg";
import lbd11 from "../assets/images/lbd11.jpg";
import lbd12 from "../assets/images/lbd12.jpg";
import lbd13 from "../assets/images/lbd13.jpg";
import lbd14 from "../assets/images/lbd14.jpg";
import lbd15 from "../assets/images/lbd15.jpg";
import lbd16 from "../assets/images/lbd16.jpg";
import lbd17 from "../assets/images/lbd17.jpg";
import lbd18 from "../assets/images/lbd18.jpg";
import lbd19 from "../assets/images/lbd19.jpg";
import lbd20 from "../assets/images/lbd20.jpg";
import lbd21 from "../assets/images/lbd21.jpg";
import lbd22 from "../assets/images/lbd22.jpg";
import lbd23 from "../assets/images/lbd23.jpg";
import lbd24 from "../assets/images/lbd24.jpg";
import lbd25 from "../assets/images/lbd25.jpg";
import lbd26 from "../assets/images/lbd26.jpg";
import lbd27 from "../assets/images/lbd27.jpg";
import m1 from "../assets/images/m1.jpg";
import m2 from "../assets/images/m2.jpg";
import m3 from "../assets/images/m3.jpg";
import m4 from "../assets/images/m4.jpg";
import m5 from "../assets/images/m5.jpg";
import m6 from "../assets/images/m6.jpg";
import m7 from "../assets/images/m7.jpg";
import m8 from "../assets/images/m8.jpg";
import m9 from "../assets/images/m9.jpg";
import m10 from "../assets/images/m10.jpg";
import m11 from "../assets/images/m11.jpg";
import m12 from "../assets/images/m12.jpg";
import m13 from "../assets/images/m13.jpg";
import m14 from "../assets/images/m14.jpg";
import m15 from "../assets/images/m15.jpg";
import m16 from "../assets/images/m16.jpg";
import m17 from "../assets/images/m17.jpg";
import m18 from "../assets/images/m18.jpg";
import m19 from "../assets/images/m19.jpg";
import m20 from "../assets/images/m20.jpg";
import m21 from "../assets/images/m21.jpg";
import m22 from "../assets/images/m22.jpg";
import m23 from "../assets/images/m23.jpg";
import m24 from "../assets/images/m24.jpg";
import m25 from "../assets/images/m25.jpg";
import m26 from "../assets/images/m26.jpg";
import m27 from "../assets/images/m27.jpg";
import m28 from "../assets/images/m28.jpg";
import m29 from "../assets/images/m29.jpg";
import m30 from "../assets/images/m30.jpg";
import m31 from "../assets/images/m31.jpg";
import m32 from "../assets/images/m32.jpg";
import m33 from "../assets/images/m33.jpg";
import m34 from "../assets/images/m34.jpg";
import m35 from "../assets/images/m35.jpg";
import m36 from "../assets/images/m36.jpg";
import m37 from "../assets/images/m37.jpg";
import m38 from "../assets/images/m38.jpg";
import m39 from "../assets/images/m39.jpg";
import m40 from "../assets/images/m40.jpg";
import m41 from "../assets/images/m41.jpg";
import m42 from "../assets/images/m42.jpg";
import m43 from "../assets/images/m43.jpg";
import m44 from "../assets/images/m44.jpg";
import p1 from "../assets/images/p1.jpg";
import p2 from "../assets/images/p2.jpg";
import p3 from "../assets/images/p3.jpg";
import p4 from "../assets/images/p4.jpg";
import p5 from "../assets/images/p5.jpg";
import p6 from "../assets/images/p6.jpg";
import p7 from "../assets/images/p7.jpg";
import p8 from "../assets/images/p8.jpg";
import sivepozadine from "../assets/images/sivepozadine.jpg";
import store from "../assets/images/store.jpg";
import atelier from "../assets/images/atelier.jpg";
import k from "../assets/images/Kina.JPG";
import k1 from "../assets/images/Kina1.JPG";
import k2 from "../assets/images/Kina2.JPG";
import k3 from "../assets/images/Kina3.JPG";
import k4 from "../assets/images/Kina4.JPG";
import k5 from "../assets/images/Kina5.JPG";
import k6 from "../assets/images/Kina6.JPG";
import k7 from "../assets/images/Kina7.JPG";
import h1 from "../assets/images/h1.jpg";
import h2 from "../assets/images/h2.jpg";
import h3 from "../assets/images/h3.jpg";
import radionica from "../assets/images/radionica.jpg";
import skice from "../assets/images/skice.png";
import decon from "../assets/images/decon.jpg";
// import decon2 from "../assets/images/decon2.png";
import dc1 from "../assets/images/DeconstructedNews/1.jpg";
import dc2 from "../assets/images/DeconstructedNews/2.jpg";
import dc3 from "../assets/images/DeconstructedNews/3.jpg";
import dc4 from "../assets/images/DeconstructedNews/4.jpg";
import dc5 from "../assets/images/DeconstructedNews/5.jpg";
import dc6 from "../assets/images/DeconstructedNews/6.jpg";
import dc7 from "../assets/images/DeconstructedNews/7.jpg";
import dc8 from "../assets/images/DeconstructedNews/8.jpg";
import dc9 from "../assets/images/DeconstructedNews/9.jpg";
import dc10 from "../assets/images/DeconstructedNews/10.jpg";
import dc11 from "../assets/images/DeconstructedNews/11.jpg";
import dc12 from "../assets/images/DeconstructedNews/12.jpg";
import dc13 from "../assets/images/DeconstructedNews/13.jpg";
import dc14 from "../assets/images/DeconstructedNews/14.jpg";
import dc15 from "../assets/images/DeconstructedNews/15.jpg";
import dc16 from "../assets/images/DeconstructedNews/16.jpg";
import dc17 from "../assets/images/DeconstructedNews/17.jpg";
import dc18 from "../assets/images/DeconstructedNews/18.jpg";
import dc19 from "../assets/images/DeconstructedNews/19.jpg";
import r1 from "../assets/images/Deconstructed/1r.jpg";
import r2 from "../assets/images/Deconstructed/2r.jpg";
import r3 from "../assets/images/Deconstructed/3r.jpg";
import r4 from "../assets/images/Deconstructed/4r.JPG";
import r5 from "../assets/images/Deconstructed/5r.jpg";
import r6 from "../assets/images/Deconstructed/6r.jpg";
import r7 from "../assets/images/Deconstructed/7r.JPG";
import r8 from "../assets/images/Deconstructed/8r.JPG";
import r9 from "../assets/images/Deconstructed/9r.jpg";
import r10 from "../assets/images/Deconstructed/10r.jpg";
import r11 from "../assets/images/Deconstructed/11r.JPG";
import r12 from "../assets/images/Deconstructed/12r.JPG";
import r13 from "../assets/images/Deconstructed/13r.jpg";
import r14 from "../assets/images/Deconstructed/14r.JPG";
import r15 from "../assets/images/Deconstructed/15r.JPG";
import r16 from "../assets/images/Deconstructed/16r.JPG";
import r17 from "../assets/images/Deconstructed/17r.JPG";
import r18 from "../assets/images/Deconstructed/18r.JPG";
import r19 from "../assets/images/Deconstructed/19r.JPG";
import r20 from "../assets/images/Deconstructed/20r.JPG";
import r21 from "../assets/images/Deconstructed/21r.JPG";
import r22 from "../assets/images/Deconstructed/22r.JPG";
import r23 from "../assets/images/Deconstructed/23r.JPG";
import r24 from "../assets/images/Deconstructed/24r.JPG";
import r25 from "../assets/images/Deconstructed/25r.JPG";
import r26 from "../assets/images/Deconstructed/26r.JPG";
import r27 from "../assets/images/Deconstructed/27r.JPG";
import r28 from "../assets/images/Deconstructed/28r.JPG";
import r29 from "../assets/images/Deconstructed/29r.JPG";
import r30 from "../assets/images/Deconstructed/30r.JPG";
import r31 from "../assets/images/Deconstructed/31r.JPG";
import r32 from "../assets/images/Deconstructed/32r.JPG";
import r33 from "../assets/images/Deconstructed/33r.JPG";
import r34 from "../assets/images/Deconstructed/34r.JPG";
import r35 from "../assets/images/Deconstructed/35r.JPG";
import r36 from "../assets/images/Deconstructed/36r.JPG";
import r37 from "../assets/images/Deconstructed/37r.JPG";
import r38 from "../assets/images/Deconstructed/38r.JPG";
import r39 from "../assets/images/Deconstructed/39r.JPG";
import r40 from "../assets/images/Deconstructed/40r.JPG";
import r41 from "../assets/images/Deconstructed/41r.JPG";
import r42 from "../assets/images/Deconstructed/42r.JPG";
import r43 from "../assets/images/Deconstructed/43r.JPG";
import r44 from "../assets/images/Deconstructed/44r.JPG";
import r45 from "../assets/images/Deconstructed/45r.JPG";
import r46 from "../assets/images/Deconstructed/46r.JPG";
import r47 from "../assets/images/Deconstructed/47r.JPG";
import r48 from "../assets/images/Deconstructed/48r.JPG";
import o1 from "../assets/images/origami/o1.jpg";
import o2 from "../assets/images/origami/o2.jpg";
import o3 from "../assets/images/origami/o3.jpg";
import o4 from "../assets/images/origami/o4.jpg";
import o5 from "../assets/images/origami/o5.jpg";
import pc1 from "../assets/images/priceless/p1.jpg";
import pc2 from "../assets/images/priceless/p2.jpg";
import pc3 from "../assets/images/priceless/p3.jpg";
import pc4 from "../assets/images/priceless/p4.jpg";
import pc5 from "../assets/images/priceless/p5.jpg";
import pc6 from "../assets/images/priceless/p6.jpg";
import pc7 from "../assets/images/priceless/p7.jpg";
import pc8 from "../assets/images/priceless/p8.jpg";
import pc9 from "../assets/images/priceless/p9.jpg";
import pc10 from "../assets/images/priceless/p10.jpg";
import pc11 from "../assets/images/priceless/p11.jpg";
import pc12 from "../assets/images/priceless/p12.jpg";
import pc13 from "../assets/images/priceless/p13.jpg";
import pc14 from "../assets/images/priceless/p14.jpg";
import pc15 from "../assets/images/priceless/p15.jpg";
import pc16 from "../assets/images/priceless/p16.jpg";
import pc17 from "../assets/images/priceless/p17.jpg";
import pc18 from "../assets/images/priceless/p18.jpg";
import pc19 from "../assets/images/priceless/p19.jpg";
import pc20 from "../assets/images/priceless/p20.jpg";
import pc21 from "../assets/images/priceless/p21.jpg";
import pc22 from "../assets/images/priceless/p22.jpg";
import pc23 from "../assets/images/priceless/p23.jpg";
import pc24 from "../assets/images/priceless/p24.jpg";
import pc25 from "../assets/images/priceless/p25.jpg";
import pc26 from "../assets/images/priceless/p26.jpg";
import pc27 from "../assets/images/priceless/p27.jpg";
import pc28 from "../assets/images/priceless/p28.jpg";
import pc29 from "../assets/images/priceless/p29.jpg";
import pc30 from "../assets/images/priceless/p30.jpg";
import pc31 from "../assets/images/priceless/p31.jpg";
import pc32 from "../assets/images/priceless/p32.jpg";
import pc33 from "../assets/images/priceless/p33.jpg";
import c1 from "../assets/images/cruise/c1.jpg";
import c2 from "../assets/images/cruise/c2.jpg";
import c3 from "../assets/images/cruise/c3.jpg";
import c4 from "../assets/images/cruise/c4.jpg";
import c5 from "../assets/images/cruise/c5.jpg";
import c6 from "../assets/images/cruise/c6.jpg";
import c7 from "../assets/images/cruise/c7.jpg";
import c8 from "../assets/images/cruise/c8.jpg";
import c9 from "../assets/images/cruise/c9.jpg";
import c10 from "../assets/images/cruise/c10.jpg";
import c11 from "../assets/images/cruise/c11.jpg";
import c12 from "../assets/images/cruise/c12.jpg";
import c13 from "../assets/images/cruise/c13.jpg";
import c14 from "../assets/images/cruise/c14.jpg";
import c15 from "../assets/images/cruise/c15.jpg";
import c16 from "../assets/images/cruise/c16.jpg";
import c17 from "../assets/images/cruise/c17.jpg";
import c18 from "../assets/images/cruise/c18.jpg";
import c19 from "../assets/images/cruise/c19.jpg";
import c20 from "../assets/images/cruise/c20.jpg";
import c21 from "../assets/images/cruise/c21.jpg";
import c22 from "../assets/images/cruise/c22.jpg";
import c23 from "../assets/images/cruise/c23.jpg";
import c24 from "../assets/images/cruise/c24.jpg";
import c25 from "../assets/images/cruise/c25.jpg";
import c26 from "../assets/images/cruise/c26.jpg";
import c27 from "../assets/images/cruise/c27.jpg";
import c28 from "../assets/images/cruise/c28.jpg";
import c29 from "../assets/images/cruise/c29.jpg";
import c30 from "../assets/images/cruise/c30.jpg";
import c31 from "../assets/images/cruise/c31.jpg";
import c32 from "../assets/images/cruise/c32.jpg";
import c33 from "../assets/images/cruise/c33.jpg";
import c34 from "../assets/images/cruise/c34.jpg";
import c35 from "../assets/images/cruise/c35.jpg";
import c36 from "../assets/images/cruise/c36.jpg";
import c37 from "../assets/images/cruise/c37.jpg";
import c38 from "../assets/images/cruise/c38.jpg";
import c39 from "../assets/images/cruise/c39.jpg";
import mm1 from "../assets/images/med i mleko/mm1.jpg";
import mm2 from "../assets/images/med i mleko/mm2.jpg";
import mm3 from "../assets/images/med i mleko/mm3.jpg";
import mm4 from "../assets/images/med i mleko/mm4.jpg";
import mm5 from "../assets/images/med i mleko/mm5.jpg";
import mm6 from "../assets/images/med i mleko/mm6.jpg";
import mm7 from "../assets/images/med i mleko/mm7.jpg";
import mm8 from "../assets/images/med i mleko/mm8.jpg";
import ml9 from "../assets/images/merletto/m9.jpg";
import ml10 from "../assets/images/merletto/m10.jpg";
import ml11 from "../assets/images/merletto/m11.jpg";
import ml12 from "../assets/images/merletto/m12.jpg";
import ml13 from "../assets/images/merletto/m13.jpg";
import ml14 from "../assets/images/merletto/m14.jpg";
import ml15 from "../assets/images/merletto/m15.jpg";
import ml16 from "../assets/images/merletto/m16.jpg";
import ml17 from "../assets/images/merletto/m17.jpg";
import ml18 from "../assets/images/merletto/m18.jpg";
import ml19 from "../assets/images/merletto/m19.jpg";
import ml20 from "../assets/images/merletto/m20.jpg";
import ml21 from "../assets/images/merletto/m21.jpg";
import ml22 from "../assets/images/merletto/m22.jpg";
import ml23 from "../assets/images/merletto/m23.jpg";
import ml24 from "../assets/images/merletto/m24.jpg";
import ml25 from "../assets/images/merletto/m25.jpg";
import b1 from "../assets/images/butterfly/b1.jpg";
import b2 from "../assets/images/butterfly/b2.jpg";
import b3 from "../assets/images/butterfly/b3.jpg";
import b4 from "../assets/images/butterfly/b4.jpg";
import b5 from "../assets/images/butterfly/b5.jpg";
import b6 from "../assets/images/butterfly/b6.jpg";
import b7 from "../assets/images/butterfly/b7.jpg";
import b8 from "../assets/images/butterfly/b8.jpg";
import b9 from "../assets/images/butterfly/b9.jpg";
import b10 from "../assets/images/butterfly/b10.jpg";
import b11 from "../assets/images/butterfly/b11.jpg";
import b12 from "../assets/images/butterfly/b12.jpg";
import b13 from "../assets/images/butterfly/b13.jpg";
import b14 from "../assets/images/butterfly/b14.jpg";
import b15 from "../assets/images/butterfly/b15.jpg";
import b16 from "../assets/images/butterfly/b16.jpg";
import b17 from "../assets/images/butterfly/b17.jpg";
import b18 from "../assets/images/butterfly/b18.jpg";
import blck1 from "../assets/images/black/blck1.jpg";
import blck2 from "../assets/images/black/blck2.jpg";
import blck3 from "../assets/images/black/blck3.jpg";
import blck4 from "../assets/images/black/blck4.jpg";
import blck5 from "../assets/images/black/blck5.jpg";
import blck6 from "../assets/images/black/blck6.jpg";
import blck7 from "../assets/images/black/blck7.jpg";
import blck8 from "../assets/images/black/blck8.jpg";
import blck9 from "../assets/images/black/blck9.jpg";
import blck10 from "../assets/images/black/blck10.jpg";
import blck11 from "../assets/images/black/blck11.jpg";
import blck12 from "../assets/images/black/blck12.jpg";
import blck13 from "../assets/images/black/blck13.jpg";
import blck14 from "../assets/images/black/blck14.jpg";
import blck15 from "../assets/images/black/blck15.jpg";
import blck16 from "../assets/images/black/blck16.jpg";
import blck17 from "../assets/images/black/blck17.jpg";
import blck18 from "../assets/images/black/blck18.jpg";
import blck19 from "../assets/images/black/blck19.jpg";
import blck20 from "../assets/images/black/blck20.jpg";
import blck21 from "../assets/images/black/blck21.jpg";
import blck22 from "../assets/images/black/blck22.jpg";
import blck23 from "../assets/images/black/blck23.jpg";
import blck24 from "../assets/images/black/blck24.jpg";
import blck25 from "../assets/images/black/blck25.jpg";
import blck26 from "../assets/images/black/blck26.jpg";
import blck27 from "../assets/images/black/blck27.jpg";
import blck28 from "../assets/images/black/blck28.jpg";
import blck29 from "../assets/images/black/blck29.jpg";
import ml1 from "../assets/images/merletto/m1.jpg";
import ml2 from "../assets/images/merletto/m2.jpg";
import ml3 from "../assets/images/merletto/m3.jpg";
import ml4 from "../assets/images/merletto/m4.jpg";
import ml5 from "../assets/images/merletto/m5.jpg";
import ml6 from "../assets/images/merletto/m6.jpg";
import ml7 from "../assets/images/merletto/m7.jpg";
import ml8 from "../assets/images/merletto/m8.jpg";
import ii1 from "../assets/images/igor by igor/ii1.jpg";
import ii2 from "../assets/images/igor by igor/ii2.jpg";
import ii3 from "../assets/images/igor by igor/ii3.jpg";
import ii4 from "../assets/images/igor by igor/ii4.jpg";
import ii5 from "../assets/images/igor by igor/ii5.jpg";
import ii6 from "../assets/images/igor by igor/ii6.jpg";
import ii7 from "../assets/images/igor by igor/ii7.jpg";
import ii8 from "../assets/images/igor by igor/ii8.jpg";
import ii9 from "../assets/images/igor by igor/ii9.jpg";
import ii10 from "../assets/images/igor by igor/ii10.jpg";
import ii11 from "../assets/images/igor by igor/ii11.jpg";
import ii12 from "../assets/images/igor by igor/ii12.jpg";
import ii13 from "../assets/images/igor by igor/ii13.jpg";
import ii14 from "../assets/images/igor by igor/ii14.jpg";
import ii15 from "../assets/images/igor by igor/ii15.jpg";
import ii16 from "../assets/images/igor by igor/ii16.jpg";
import ii17 from "../assets/images/igor by igor/ii17.jpg";
import ii18 from "../assets/images/igor by igor/ii18.jpg";
import ii19 from "../assets/images/igor by igor/ii19.jpg";
import Lora from "../assets/videos/Lora.mp4";
import videoAtelier from "../assets/videos/atelierVideo.mp4";
import sgHome3 from "../assets/images/sgHome3.jpg";
import sw1 from "../assets/images/street wear/sw1.jpg";
import sw2 from "../assets/images/street wear/sw2.jpg";
import sw3 from "../assets/images/street wear/sw3.jpg";
import sw4 from "../assets/images/street wear/sw4.jpg";
import sw5 from "../assets/images/street wear/sw5.jpg";
import sw6 from "../assets/images/street wear/sw6.jpg";
import sw7 from "../assets/images/street wear/sw7.jpg";
import sw8 from "../assets/images/street wear/sw8.jpg";
import sw9 from "../assets/images/street wear/sw9.jpg";
import sw10 from "../assets/images/street wear/sw10.jpg";
import sw11 from "../assets/images/street wear/sw11.jpg";
import sw12 from "../assets/images/street wear/sw12.jpg";
import sw13 from "../assets/images/street wear/sw13.jpg";
import sw14 from "../assets/images/street wear/sw14.jpg";
import sw15 from "../assets/images/street wear/sw15.jpg";
import sw16 from "../assets/images/street wear/sw16.jpg";
import sw17 from "../assets/images/street wear/sw17.jpg";
import sw18 from "../assets/images/street wear/sw18.jpg";
import sw19 from "../assets/images/street wear/sw19.jpg";
import sw20 from "../assets/images/street wear/sw20.jpg";
import muzej from "../assets/images/muzej.jpeg";
import muzejLogo from "../assets/images/muzejLogo.png";
import muzejLogo2 from "../assets/images/logoMuzej2.png";
import diva1 from "../assets/images/diva/diva1.jpg";
import diva2 from "../assets/images/diva/diva2.jpg";
import diva3 from "../assets/images/diva/diva3.jpg";
import diva4 from "../assets/images/diva/diva4.jpg";
import diva5 from "../assets/images/diva/diva5.jpg";
import diva6 from "../assets/images/diva/diva6.jpg";
import diva7 from "../assets/images/diva/diva7.jpg";
import diva8 from "../assets/images/diva/diva8.jpg";
import diva9 from "../assets/images/diva/diva9.jpg";
import diva10 from "../assets/images/diva/diva10.jpg";
import diva11 from "../assets/images/diva/diva11.jpg";
import diva12 from "../assets/images/diva/diva12.jpg";
import diva13 from "../assets/images/diva/diva13.jpg";
import diva14 from "../assets/images/diva/diva14.jpg";
import diva15 from "../assets/images/diva/diva15.jpg";
import diva16 from "../assets/images/diva/diva16.jpg";
import diva17 from "../assets/images/diva/diva17.jpg";
import diva18 from "../assets/images/diva/diva18.jpg";
import diva19 from "../assets/images/diva/diva19.jpg";
import diva20 from "../assets/images/diva/diva20.jpg";
import diva21 from "../assets/images/diva/diva21.jpg";
import diva22 from "../assets/images/diva/diva22.jpg";
import diva23 from "../assets/images/diva/diva23.jpg";
import diva24 from "../assets/images/diva/diva24.jpg";
import diva25 from "../assets/images/diva/diva25.jpg";
import diva26 from "../assets/images/diva/diva26.jpg";
import diva27 from "../assets/images/diva/diva27.jpg";
import diva28 from "../assets/images/diva/diva28.jpg";
import diva29 from "../assets/images/diva/diva29.jpg";
import diva30 from "../assets/images/diva/diva30.jpg";
import diva31 from "../assets/images/diva/diva31.jpg";
import diva32 from "../assets/images/diva/diva32.jpg";
import diva33 from "../assets/images/diva/diva33.jpg";
import diva34 from "../assets/images/diva/diva34.jpg";
import diva35 from "../assets/images/diva/diva35.jpg";
import diva36 from "../assets/images/diva/diva36.jpg";
import diva37 from "../assets/images/diva/diva37.jpg";
import diva38 from "../assets/images/diva/diva38.jpg";
import diva39 from "../assets/images/diva/diva39.jpg";
import diva40 from "../assets/images/diva/diva40.jpg";
import diva41 from "../assets/images/diva/diva41.jpg";
import diva42 from "../assets/images/diva/diva42.jpg";
import diva43 from "../assets/images/diva/diva43.jpg";
import diva44 from "../assets/images/diva/diva44.jpg";
import diva45 from "../assets/images/diva/diva45.jpg";
import diva46 from "../assets/images/diva/diva46.jpg";
import diva47 from "../assets/images/diva/diva47.jpg";
import diva48 from "../assets/images/diva/diva48.jpg";
import diva49 from "../assets/images/diva/diva49.jpg";
import diva50 from "../assets/images/diva/diva50.jpg";
import diva51 from "../assets/images/diva/diva51.jpg";
import diva52 from "../assets/images/diva/diva52.jpg";
import diva53 from "../assets/images/diva/diva53.jpg";
import diva54 from "../assets/images/diva/diva54.jpg";
import diva55 from "../assets/images/diva/diva55.jpg";
import diva56 from "../assets/images/diva/diva56.jpg";
import diva57 from "../assets/images/diva/diva57.jpg";
import diva58 from "../assets/images/diva/diva58.jpg";
import diva59 from "../assets/images/diva/diva59.jpg";
import diva60 from "../assets/images/diva/diva60.jpg";
import diva61 from "../assets/images/diva/diva61.jpg";
import diva62 from "../assets/images/diva/diva62.jpg";
import diva63 from "../assets/images/diva/diva63.jpg";
import diva64 from "../assets/images/diva/diva64.jpg";
import diva65 from "../assets/images/diva/diva65.jpg";
import diva66 from "../assets/images/diva/diva66.jpg";
import diva67 from "../assets/images/diva/diva67.jpg";
import diva68 from "../assets/images/diva/diva68.jpg";
import diva69 from "../assets/images/diva/diva69.jpg";
import diva70 from "../assets/images/diva/diva70.jpg";
import bloom1 from "../assets/images/blooming/bloom1.jpg";
import bloom2 from "../assets/images/blooming/bloom2.jpg";
import bloom3 from "../assets/images/blooming/bloom3.jpg";
import bloom4 from "../assets/images/blooming/bloom4.jpg";
import bloom5 from "../assets/images/blooming/bloom5.jpg";
import bloom6 from "../assets/images/blooming/bloom6.jpg";
import bloom7 from "../assets/images/blooming/bloom7.jpg";
import bloom8 from "../assets/images/blooming/bloom8.jpg";
import bloom9 from "../assets/images/blooming/bloom9.jpg";
import bloom10 from "../assets/images/blooming/bloom10.jpg";
import bloom11 from "../assets/images/blooming/bloom11.jpg";
import bloom12 from "../assets/images/blooming/bloom12.jpg";
import bloom13 from "../assets/images/blooming/bloom13.jpg";
import bloom14 from "../assets/images/blooming/bloom14.jpg";
import bloom15 from "../assets/images/blooming/bloom15.jpg";
import bloom16 from "../assets/images/blooming/bloom16.jpg";
import bloom17 from "../assets/images/blooming/bloom17.jpg";
import bloom18 from "../assets/images/blooming/bloom18.jpg";
import bloom19 from "../assets/images/blooming/bloom19.jpg";
import bloom20 from "../assets/images/blooming/bloom20.jpg";
import bloom21 from "../assets/images/blooming/bloom21.jpg";
import bloom22 from "../assets/images/blooming/bloom22.jpg";
import bloom23 from "../assets/images/blooming/bloom23.jpg";
import bloom24 from "../assets/images/blooming/bloom24.jpg";
import bloom25 from "../assets/images/blooming/bloom25.jpg";
import bloom26 from "../assets/images/blooming/bloom26.jpg";
import bloom27 from "../assets/images/blooming/bloom27.jpg";
import bloom28 from "../assets/images/blooming/bloom28.jpg";
import bloom29 from "../assets/images/blooming/bloom29.jpg";
import bloom30 from "../assets/images/blooming/bloom30.jpg";
import bloom31 from "../assets/images/blooming/bloom31.jpg";
import bloom32 from "../assets/images/blooming/bloom32.jpg";
import bloom33 from "../assets/images/blooming/bloom33.jpg";
import bloom34 from "../assets/images/blooming/bloom34.jpg";
import bloom35 from "../assets/images/blooming/bloom35.jpg";
import bloom36 from "../assets/images/blooming/bloom36.jpg";
import bloom37 from "../assets/images/blooming/bloom37.jpg";
import bloom38 from "../assets/images/blooming/bloom38.jpg";
import bloom39 from "../assets/images/blooming/bloom39.jpg";
import bloom40 from "../assets/images/blooming/bloom40.jpg";
import bloomMain from "../assets/images/bloomLand.jpg";
import divaMain from "../assets/images/divaMain.jpg";
import karl1 from "../assets/images/karlneval/karl1.jpg";
import karl2 from "../assets/images/karlneval/karl2.jpg";
import karl3 from "../assets/images/karlneval/karl3.jpg";
import karl4 from "../assets/images/karlneval/karl4.jpg";
import karl5 from "../assets/images/karlneval/karl5.jpg";
import karl6 from "../assets/images/karlneval/karl6.jpg";
import karl7 from "../assets/images/karlneval/karl7.jpg";
import karl8 from "../assets/images/karlneval/karl8.jpg";
import karl9 from "../assets/images/karlneval/karl9.jpg";
import karl10 from "../assets/images/karlneval/karl10.jpg";
import karl11 from "../assets/images/karlneval/karl11.jpg";
import karl12 from "../assets/images/karlneval/karl12.jpg";
import karl13 from "../assets/images/karlneval/karl13.jpg";
import karl14 from "../assets/images/karlneval/karl14.jpg";
import karl15 from "../assets/images/karlneval/karl15.jpg";
import karl16 from "../assets/images/karlneval/karl16.jpg";
import karl17 from "../assets/images/karlneval/karl17.jpg";
import karl18 from "../assets/images/karlneval/karl18.jpg";
import karl19 from "../assets/images/karlneval/karl19.jpg";
import karl20 from "../assets/images/karlneval/karl20.jpg";
import karl21 from "../assets/images/karlneval/karl21.jpg";
import karl22 from "../assets/images/karlneval/karl22.jpg";
import karl23 from "../assets/images/karlneval/karl23.jpg";
import karl24 from "../assets/images/karlneval/karl24.jpg";
import karl25 from "../assets/images/karlneval/karl25.jpg";
import karl26 from "../assets/images/karlneval/karl26.jpg";
import karl27 from "../assets/images/karlneval/karl27.jpg";
import karl28 from "../assets/images/karlneval/karl28.jpg";
import karl29 from "../assets/images/karlneval/karl29.jpg";
import karl30 from "../assets/images/karlneval/karl30.jpg";
import karl31 from "../assets/images/karlneval/karl31.jpg";
import karl32 from "../assets/images/karlneval/karl32.jpg";
import karl33 from "../assets/images/karlneval/karl33.jpg";
import karl34 from "../assets/images/karlneval/karl34.jpg";
import karl35 from "../assets/images/karlneval/karl35.jpg";
import karl36 from "../assets/images/karlneval/karl36.jpg";
import karl37 from "../assets/images/karlneval/karl37.jpg";
import karl38 from "../assets/images/karlneval/karl38.jpg";
import karl39 from "../assets/images/karlneval/karl39.jpg";
import karl40 from "../assets/images/karlneval/karl40.jpg";
import karl41 from "../assets/images/karlneval/karl41.jpg";
import karl42 from "../assets/images/karlneval/karl42.jpg";
import karl43 from "../assets/images/karlneval/karl43.jpg";
import karl44 from "../assets/images/karlneval/karl44.jpg";
import karl45 from "../assets/images/karlneval/karl45.jpg";
import karl46 from "../assets/images/karlneval/karl46.jpg";
import karlMain from "../assets/images/karlMain.jpg";

const data = {
  popup: {
    maintitle: {
      Srpski: "NEWS",
      English: "NEWS",
      Italian: "NEWS",
    },
    maintitle2: {
      Srpski: "LETTER",
      English: "LETTER",
      Italian: "LETTER",
    },
    text: {
      Srpski: "NEWSLETTER",
      English: "NEWSLETTER",
      Italian: "NEWSLETTER",
    },
    title: {
      Srpski:
        "AKCIJA na modele iz Deconstructed kolekcije ! Do 20% popusta ! Prijavite se i među prvima saznajte najnovije vesti",
      English:
        "SALE on products from the Deconstructed collection ! Up to 20% off ! Sign up and find out the latest news",
      Italian:
        "Sconto sui prodotti della collezione Deconstructed! Fino al 20% di sconto! Iscriviti e scopri le ultime novità",
    },
    description: {
      Srpski: "Ne prikazuj više",
      English: "Dont show this again",
      Italian: "Non mostrare più questo",
    },
  },
  singleCollection: [
    {
      title: {
        Srpski: "BLOOMING",
        English: "BLOOMING",
        Italian: "BLOOMING",
      },
      photos: [
        {
          image: bloom1,
          orientation: "portrait",
        },
        {
          image: bloom2,
          orientation: "portrait",
        },
        {
          image: bloom3,
          orientation: "portrait",
        },
        {
          image: bloom4,
          orientation: "portrait",
        },
        {
          image: bloom5,
          orientation: "portrait",
        },
        {
          image: bloom6,
          orientation: "portrait",
        },
        {
          image: bloom7,
          orientation: "portrait",
        },
        {
          image: bloom8,
          orientation: "portrait",
        },
        {
          image: bloom9,
          orientation: "portrait",
        },
        {
          image: bloom10,
          orientation: "portrait",
        },
        {
          image: bloom11,
          orientation: "portrait",
        },
        {
          image: bloom12,
          orientation: "portrait",
        },
        {
          image: bloom13,
          orientation: "portrait",
        },
        {
          image: bloom14,
          orientation: "portrait",
        },
        {
          image: bloom15,
          orientation: "portrait",
        },
        {
          image: bloom16,
          orientation: "portrait",
        },
        {
          image: bloom17,
          orientation: "portrait",
        },
        {
          image: bloom18,
          orientation: "portrait",
        },
        {
          image: bloom19,
          orientation: "portrait",
        },
        {
          image: bloom20,
          orientation: "portrait",
        },
        {
          image: bloom21,
          orientation: "portrait",
        },
        {
          image: bloom22,
          orientation: "portrait",
        },
        {
          image: bloom23,
          orientation: "portrait",
        },
        {
          image: bloom24,
          orientation: "portrait",
        },
        {
          image: bloom25,
          orientation: "portrait",
        },
        {
          image: bloom26,
          orientation: "portrait",
        },
        {
          image: bloom27,
          orientation: "portrait",
        },
        {
          image: bloom28,
          orientation: "portrait",
        },
        {
          image: bloom29,
          orientation: "portrait",
        },
        {
          image: bloom30,
          orientation: "portrait",
        },
        {
          image: bloom31,
          orientation: "portrait",
        },
        {
          image: bloom32,
          orientation: "portrait",
        },
        {
          image: bloom33,
          orientation: "portrait",
        },
        {
          image: bloom34,
          orientation: "portrait",
        },
        {
          image: bloom35,
          orientation: "portrait",
        },
        {
          image: bloom36,
          orientation: "portrait",
        },
        {
          image: bloom37,
          orientation: "portrait",
        },
        {
          image: bloom38,
          orientation: "portrait",
        },
        {
          image: bloom39,
          orientation: "portrait",
        },
        {
          image: bloom40,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "BLOOMIN",
        English: "BLOOMIN",
        Italian: "BLOOMIN",
      },
      description: {
        Srpski:
          "Kolekcija koja nosi ovaj naziv metaforično govori o nastavku rada naše radionice i dizajnerskog potpisa Atelje Igor Todorović, nakon perioda u kome smo kao i sve naše kolege prošli težak i trnovit put opstanka modne priče. U stvaralačkom naboju , realizovano je nekoliko grupa odevnih komada , gde nismo odustali od najplemenitijih i pažljivo biranih tkanina. Za ovu kolekciju smo samostalno dizajnirali materijal na pruge koji je rađen u odnosu na konstrukciji odevnih predmeta iz te grupe. Svilene haljine i pantalone lepršavog kroja kao i odevni komadi u crnoj i beloj boji u klasičnom spoju dve ne boje. Oba kolekcija je omnibus stila Atelje Igor Todorovic i kao takva je izazvala veliku pažnju i postovanje naše klijentele i zaljubljenika u nas rad. Hvala na tome i zato nam je maksima za dalje - keep Blooming.",
        English:
          "The collection that carries this name metaphorically tells the story of the continuation of activity of our Atelier and the designer’s signature of Igor Todorovic after a period in which –as the rest of our colleagues- we have walked the hard and thorny path of fashion’s survival. In our resulting creative charge we made a series of clothing lines, where we did not give up on the use of the noblest and most carefully selected fabrics. For this collection we independently designed a striped material which was developed specifically for the clothing of this line. Silk dresses and trousers of a breezy cut, as well as other pieces in black and white - the classic combination of the two “non-colours”. This collection is the omnibus of the style of Atelier Igor Todorovic, and as such has provoked great interest and inspired respect from our clients and fans of our work. Thank you ever so much, and thus from now on our maxim will be “keep Blooming”.",
        Italian:
          "Kolekcija koja nosi ovaj naziv metaforično govori o nastavku rada naše radionice i dizajnerskog potpisa Atelje Igor Todorović, nakon perioda u kome smo kao i sve naše kolege prošli težak i trnovit put opstanka modne priče. U stvaralačkom naboju , realizovano je nekoliko grupa odevnih komada , gde nismo odustali od najplemenitijih i pažljivo biranih tkanina. Za ovu kolekciju smo samostalno dizajnirali materijal na pruge koji je rađen u odnosu na konstrukciji odevnih predmeta iz te grupe. Svilene haljine i pantalone lepršavog kroja kao i odevni komadi u crnoj i beloj boji u klasičnom spoju dve ne boje. Oba kolekcija je omnibus stila Atelje Igor Todorovic i kao takva je izazvala veliku pažnju i postovanje naše klijentele i zaljubljenika u nas rad. Hvala na tome i zato nam je maksima za dalje - keep Blooming.",
      },
    },
    {
      title: {
        Srpski: "DIVA",
        English: "DIVA",
        Italian: "DIVA",
      },
      photos: [
        {
          image: diva1,
          orientation: "portrait",
        },
        {
          image: diva2,
          orientation: "portrait",
        },
        {
          image: diva3,
          orientation: "portrait",
        },
        {
          image: diva4,
          orientation: "portrait",
        },
        {
          image: diva5,
          orientation: "portrait",
        },
        {
          image: diva6,
          orientation: "portrait",
        },
        {
          image: diva7,
          orientation: "portrait",
        },
        {
          image: diva8,
          orientation: "portrait",
        },
        {
          image: diva9,
          orientation: "portrait",
        },
        {
          image: diva10,
          orientation: "portrait",
        },
        {
          image: diva11,
          orientation: "portrait",
        },
        {
          image: diva12,
          orientation: "portrait",
        },
        {
          image: diva13,
          orientation: "portrait",
        },
        {
          image: diva14,
          orientation: "portrait",
        },
        {
          image: diva15,
          orientation: "portrait",
        },
        {
          image: diva16,
          orientation: "portrait",
        },
        {
          image: diva17,
          orientation: "portrait",
        },
        {
          image: diva18,
          orientation: "portrait",
        },
        {
          image: diva19,
          orientation: "portrait",
        },
        {
          image: diva20,
          orientation: "portrait",
        },
        {
          image: diva21,
          orientation: "portrait",
        },
        {
          image: diva22,
          orientation: "portrait",
        },
        {
          image: diva23,
          orientation: "portrait",
        },
        {
          image: diva24,
          orientation: "portrait",
        },
        {
          image: diva25,
          orientation: "portrait",
        },
        {
          image: diva26,
          orientation: "portrait",
        },
        {
          image: diva27,
          orientation: "portrait",
        },
        {
          image: diva28,
          orientation: "portrait",
        },
        {
          image: diva29,
          orientation: "portrait",
        },
        {
          image: diva30,
          orientation: "portrait",
        },
        {
          image: diva31,
          orientation: "portrait",
        },
        {
          image: diva32,
          orientation: "portrait",
        },
        {
          image: diva33,
          orientation: "portrait",
        },
        {
          image: diva34,
          orientation: "portrait",
        },
        {
          image: diva35,
          orientation: "portrait",
        },
        {
          image: diva36,
          orientation: "portrait",
        },
        {
          image: diva37,
          orientation: "portrait",
        },
        {
          image: diva38,
          orientation: "portrait",
        },
        {
          image: diva39,
          orientation: "portrait",
        },
        {
          image: diva40,
          orientation: "portrait",
        },
        {
          image: diva41,
          orientation: "portrait",
        },
        {
          image: diva42,
          orientation: "portrait",
        },
        {
          image: diva43,
          orientation: "portrait",
        },
        {
          image: diva44,
          orientation: "portrait",
        },
        {
          image: diva45,
          orientation: "portrait",
        },
        {
          image: diva46,
          orientation: "portrait",
        },
        {
          image: diva47,
          orientation: "portrait",
        },
        {
          image: diva48,
          orientation: "portrait",
        },
        {
          image: diva49,
          orientation: "portrait",
        },
        {
          image: diva50,
          orientation: "portrait",
        },
        {
          image: diva51,
          orientation: "portrait",
        },
        {
          image: diva52,
          orientation: "portrait",
        },
        {
          image: diva53,
          orientation: "portrait",
        },
        {
          image: diva54,
          orientation: "portrait",
        },
        {
          image: diva55,
          orientation: "portrait",
        },
        {
          image: diva56,
          orientation: "portrait",
        },
        {
          image: diva57,
          orientation: "portrait",
        },
        {
          image: diva58,
          orientation: "portrait",
        },
        {
          image: diva59,
          orientation: "portrait",
        },
        {
          image: diva60,
          orientation: "portrait",
        },
        {
          image: diva61,
          orientation: "portrait",
        },
        {
          image: diva62,
          orientation: "portrait",
        },
        {
          image: diva63,
          orientation: "portrait",
        },
        {
          image: diva64,
          orientation: "portrait",
        },
        {
          image: diva65,
          orientation: "portrait",
        },
        {
          image: diva66,
          orientation: "portrait",
        },
        {
          image: diva67,
          orientation: "portrait",
        },
        {
          image: diva68,
          orientation: "portrait",
        },
        {
          image: diva69,
          orientation: "portrait",
        },
        {
          image: diva70,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "DIVA",
        English: "DIVA",
        Italian: "DIVA",
      },
      description: {
        Srpski:
          "Kolekcija od 12 haljina prve linije Atelje Igor Todorović posvećena je klijentima i ljubiteljima potpisa ateljea i predstavlja 12 različitih modnih priča,od koje svaka ima svoju autentičnost, estetiku i pojavnost, baš kao i svaka naša uvažena klijentkinja koja nam je kroz godine saradnje pružila poverenje. Kolekcija je koncipirana kroz odevne komade koji su izrađeni od najplemenitijih tkanina od svile, ukrašenih kristalima i ručnim doradama. Zahvaljujemo sa pomoći pri realizaciji kolekcije Fur Stevanović koji su namenski izradili nekoliko odevnih predmeta za ovu kolekciju. Ova kolekcija je autentičnih 12 krojnih linija Atelja i kao takva predstavlja ikonografiju ateljea. Uradjena je u duhu visoke mode i predstavljena je zatvorena za širu publiku, najodanijim klijentima našeg ateljea.",
        English:
          "A collection of 12 top of the line dresses of the Atelier Igor Todorovic, dedicated to clients and fans of the Atelier’s signature, representing 12 different fashion stories, all of which have their own authenticity, aesthetics, and incidence to match every one of our clients that has throughout the years deposited her trust in us. The collection is conceived using clothing made out of the noblest silk cloths decorated with crystals and hand finishing. We would like to thank “Fur Stevanovic” for their help in the realisation of this collection, as they made various pieces of clothing specifically for the same. This collection is made out of 12 authentic cuts of the Atelier, and as such also represents the iconography of the Atelier itself. It is also made in the spirit of haute couture, and has been presented exclusively to our Atelier’s most loyal clients.",
        Italian:
          "Kolekcija od 12 haljina prve linije Atelje Igor Todorović posvećena je klijentima i ljubiteljima potpisa ateljea i predstavlja 12 različitih modnih priča,od koje svaka ima svoju autentičnost, estetiku i pojavnost, baš kao i svaka naša uvažena klijentkinja koja nam je kroz godine saradnje pružila poverenje. Kolekcija je koncipirana kroz odevne komade koji su izrađeni od najplemenitijih tkanina od svile, ukrašenih kristalima i ručnim doradama. Zahvaljujemo sa pomoći pri realizaciji kolekcije Fur Stevanović koji su namenski izradili nekoliko odevnih predmeta za ovu kolekciju. Ova kolekcija je autentičnih 12 krojnih linija Atelja i kao takva predstavlja ikonografiju ateljea. Uradjena je u duhu visoke mode i predstavljena je zatvorena za širu publiku, najodanijim klijentima našeg ateljea.",
      },
    },
    {
      title: {
        Srpski: "KARLNEVAL",
        English: "KARLNEVAL",
        Italian: "KARLNEVAL",
      },
      photos: [
        {
          image: karl38,
          orientation: "portrait",
        },
        {
          image: karl39,
          orientation: "portrait",
        },
        {
          image: karl26,
          orientation: "portrait",
        },
        {
          image: karl27,
          orientation: "portrait",
        },
        {
          image: karl30,
          orientation: "portrait",
        },
        {
          image: karl31,
          orientation: "portrait",
        },
        {
          image: karl32,
          orientation: "portrait",
        },
        {
          image: karl33,
          orientation: "portrait",
        },
        {
          image: karl35,
          orientation: "portrait",
        },
        {
          image: karl36,
          orientation: "portrait",
        },
        {
          image: karl1,
          orientation: "landscape",
        },
        {
          image: karl2,
          orientation: "landscape",
        },
        {
          image: karl3,
          orientation: "landscape",
        },
        {
          image: karl4,
          orientation: "landscape",
        },
        {
          image: karl5,
          orientation: "landscape",
        },
        {
          image: karl6,
          orientation: "landscape",
        },
        {
          image: karl7,
          orientation: "landscape",
        },
        {
          image: karl8,
          orientation: "landscape",
        },
        {
          image: karl9,
          orientation: "landscape",
        },
        {
          image: karl10,
          orientation: "landscape",
        },
        {
          image: karl11,
          orientation: "landscape",
        },
        {
          image: karl12,
          orientation: "landscape",
        },
        {
          image: karl13,
          orientation: "landscape",
        },
        {
          image: karl14,
          orientation: "landscape",
        },
        {
          image: karl15,
          orientation: "landscape",
        },
        {
          image: karl16,
          orientation: "landscape",
        },
        {
          image: karl17,
          orientation: "landscape",
        },
        {
          image: karl18,
          orientation: "landscape",
        },
        {
          image: karl19,
          orientation: "landscape",
        },
        {
          image: karl20,
          orientation: "landscape",
        },
        {
          image: karl21,
          orientation: "landscape",
        },
        {
          image: karl22,
          orientation: "landscape",
        },
        {
          image: karl23,
          orientation: "landscape",
        },
        {
          image: karl24,
          orientation: "landscape",
        },
        {
          image: karl25,
          orientation: "landscape",
        },

        {
          image: karl28,
          orientation: "landscape",
        },
        {
          image: karl29,
          orientation: "landscape",
        },

        {
          image: karl34,
          orientation: "landscape",
        },

        {
          image: karl37,
          orientation: "landscape",
        },

        {
          image: karl40,
          orientation: "landscape",
        },
        {
          image: karl41,
          orientation: "landscape",
        },
        {
          image: karl42,
          orientation: "landscape",
        },
        {
          image: karl43,
          orientation: "landscape",
        },
        {
          image: karl44,
          orientation: "landscape",
        },
        {
          image: karl45,
          orientation: "landscape",
        },
        {
          image: karl46,
          orientation: "landscape",
        },
      ],
      text: {
        Srpski: "KARLNEV",
        English: "KARLNEV",
        Italian: "KARLNEV",
      },
      description: {
        Srpski: `Atelier Igor Todorović predstavlja odevne komade namenjene za dnevne i večernje prilike od  pažljivo biranih tkanina savremene tehnologije dorade i obrade, kao i svilenih organdina, saten svila, bukle svila i detalja od kristala i lamea, koje na određeni nacin definišu estetiku vedrog kolorita koji su u skladu sa aktuelnim sezonskim trendovima. Konstrukcije su kao i uvek bile posebna poslastica celom timu ateljea koji se i ovaj put trudio da istrazi nove, i inovativne nacina krojenja i spajanja tkanina koje cine kolekciju Naziv kolekcije KARLNEVAL, spoj je potrebe čovekove potrebe da se iz sezone u sezonu oblaci u novu "masku"  trenda koju moda nudi, kao i nasleđa koje nam ostaje iza velikih imena sveta mode. Moda treba da bude radost i zadovoljstvo istraživanja i novih "maski" koje će učiniti da se svako oseća posebno i autentično i zato vas pozivamo na jedan beogradski Karlneval posvećen svim onima koji prate i cene rad Ateljea Igor Todorovic.`,
        English:
          "Atelier Igor Todorovic presents daywear and evening apparel constructed of carefully chosen fabrics created through contemporary processing and finishing technology made of silk organdies, satin silks, bukle silk and crystal and lamé details that specifically define a bright color aesthetics that corresponds with current seasonal trends. The constructions, as always, were a special treat for the entire atelier team, which once again tried to explore new and innovative method of fabric tailoring and modelling that make up the collection. The name of KARLNEVAL collection is a synthesis of a human need to dress from season to season in a new trend “mask” that fashion offers, as well as the legacy that remains behind the eminent names of the fashion world. Fashion should be a joy and pleasure of exploring new “masks” that will cause everyone to feel unique and authentic, and that is why we invite you to Belgrade KARNEVAL, dedicated to those who follow and appreciate the work of Atelier Igor Todorovic.",
        Italian:
          "Atelier Igor Todorovic presents daywear and evening apparel constructed of carefully chosen fabrics created through contemporary processing and finishing technology made of silk organdies, satin silks, bukle silk and crystal and lamé details that specifically define a bright color aesthetics that corresponds with current seasonal trends. The constructions, as always, were a special treat for the entire atelier team, which once again tried to explore new and innovative method of fabric tailoring and modelling that make up the collection. The name of KARLNEVAL collection is a synthesis of a human need to dress from season to season in a new trend “mask” that fashion offers, as well as the legacy that remains behind the eminent names of the fashion world. Fashion should be a joy and pleasure of exploring new “masks” that will cause everyone to feel unique and authentic, and that is why we invite you to Belgrade KARNEVAL, dedicated to those who follow and appreciate the work of Atelier Igor Todorovic.",
      },
    },
    {
      title: {
        Srpski: "SECRET GARDEN",
        English: "SECRET GARDEN",
        Italian: "SECRET GARDEN",
      },
      photos: [
        {
          image: sg10,
          orientation: "landscape",
        },
        {
          image: sg2,
          orientation: "landscape",
        },
        {
          image: sg13,
          orientation: "landscape",
        },
        {
          image: sg15,
          orientation: "landscape",
        },
        {
          image: sg16,
          orientation: "landscape",
        },
        {
          image: sg21,
          orientation: "landscape",
        },
        {
          image: sg22,
          orientation: "landscape",
        },
        {
          image: sg26,
          orientation: "landscape",
        },

        {
          image: sg27,
          orientation: "landscape",
        },
        {
          image: sg28,
          orientation: "landscape",
        },
        {
          image: sg29,
          orientation: "landscape",
        },
        {
          image: sg30,
          orientation: "landscape",
        },
        {
          image: sg4,
          orientation: "portrait",
        },
        {
          image: sg5,
          orientation: "portrait",
        },
        {
          image: sg3,
          orientation: "landscape",
        },
        {
          image: sg6,
          orientation: "portrait",
        },
        {
          image: sg7,
          orientation: "portrait",
        },
        {
          image: sg1,
          orientation: "landscape",
        },
        {
          image: sg8,
          orientation: "portrait",
        },
        {
          image: sg9,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "SECRET G",
        English: "SECRET G",
        Italian: "SECRET G",
      },
      description: {
        Srpski:
          "Kolekcija Secret Garden manifest je tajanstvenosti ženske siluete, zavijene u brižljivo izrađene i rukom dorađene elemente koji asociraju na bršljan. Izbor tkanina i konstrukcijska rešenja dosledni su potpisu Ateljea i usmereni su na inovaciju, ali ujedno i inspirišu ženu koja želi da bude autentična i zavodljiva kroz bajkoviti svet tajanstvenog vrta modne priče nastale kroz ovu kolekciju.",
        English:
          "The collection Secret Garden is a manifest of enigmatic woman’s silhouette, wrapped in carefully crafted and hand-made elements that relate to ivy. The choice of fabric and construction solution are consistent with Atelier’s signature that is also focused on innovation and at the same time it inspires a woman who wishes to be authentic and seductive through the fairy tale world of mysterious garden within a fashion story formed through this collection.",
        Italian:
          "La collezione Secret Garden rappresenta il manifesto del mistero della silhouette femminile, avvolta in elementi accuratamente realizzati e rifiniti a mano che ricordano l’edera. La scelta dei tessuti e le soluzioni costruttive rispettano la firma dell’Atelier e sono orientati verso l’innovazione, ispirando allo stesso tempo la donna che mira ad essere autentica e seducente attraverso questo fantasioso mondo del giardino misterioso inserito nella storia della moda che è nata in questa collezione.",
      },
    },
    {
      title: {
        Srpski: "AVENUE FOCH",
        English: "AVENUE FOCH",
        Italian: "AVENUE FOCH",
      },
      photos: [
        {
          image: af1,
          orientation: "portrait",
        },
        {
          image: af2,
          orientation: "portrait",
        },
        {
          image: af3,
          orientation: "portrait",
        },
        {
          image: af4,
          orientation: "portrait",
        },
        {
          image: af5,
          orientation: "portrait",
        },
        {
          image: af6,
          orientation: "portrait",
        },
        {
          image: af7,
          orientation: "portrait",
        },
        {
          image: af8,
          orientation: "portrait",
        },
        {
          image: af9,
          orientation: "portrait",
        },
        {
          image: af10,
          orientation: "portrait",
        },
        {
          image: af11,
          orientation: "portrait",
        },
        {
          image: af12,
          orientation: "portrait",
        },
        {
          image: af13,
          orientation: "portrait",
        },
        {
          image: af14,
          orientation: "portrait",
        },
        {
          image: af15,
          orientation: "portrait",
        },
        {
          image: af16,
          orientation: "portrait",
        },
        {
          image: af17,
          orientation: "portrait",
        },
        {
          image: af18,
          orientation: "portrait",
        },
        {
          image: af19,
          orientation: "portrait",
        },
        {
          image: af20,
          orientation: "portrait",
        },
        {
          image: af21,
          orientation: "portrait",
        },
        {
          image: af22,
          orientation: "portrait",
        },
        {
          image: af23,
          orientation: "portrait",
        },
        {
          image: af24,
          orientation: "portrait",
        },
        {
          image: af25,
          orientation: "portrait",
        },
        {
          image: af26,
          orientation: "portrait",
        },
        {
          image: af27,
          orientation: "portrait",
        },
        {
          image: af28,
          orientation: "portrait",
        },
        {
          image: af29,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "AVENUE",
        English: "AVENUE",
        Italian: "AVENUE",
      },
      description: {
        Srpski:
          "Francuska šansonjerka Dalida bila je osnovna inspiracija i nit od koje je nastala kolekcija Avenue Foch. Estetika njenog odevanja je obojila formu u kojoj se, kroz svaki prikazani odevni komad, istraživao element harmonike i francuskog stila poslednjih dekada XX veka. Raskošna i scenična, ova kolekcija sadrži brojne komade od kože, krzna i šljokica i asocira na zvezdani sjaj Dalide.",
        English:
          "The French chansonniere Dalida was the basic inspiration and thread from which the Avenue Foch collection was created. The aesthetics of her attire has colored a form in which, through every presented item of clothing, the element of harmony was analyzed as well as the French style of the last decade of 20th century. Luxurious and scenic, this collection contains numerous items of leather, fur and embroidery that is associated with the starry glow of Dalida.",
        Italian:
          "La cantante francese Dalida è stata l’ispirazione principale e il filo dal quale è nata la linea Avenue Foch. L’estetica del suo stile ha colorato la forma nella quale, attraverso ogni capo d’abbigliamento mostrato, si ricercava l’elemento della fisarmonica e dello stile francese degli ultimi decenni del XX secolo. Fastosa e spettacolare, questa collezione contiene molti capi in pelle, pellicce e paillettes che ricordano lo splendore stellare di Dalida.",
      },
    },
    {
      title: {
        Srpski: "PUDRIJERA",
        English: "PUDRIJERA",
        Italian: "CIPRIA",
      },
      photos: [
        {
          image: p1,
          orientation: "portrait",
        },
        {
          image: p2,
          orientation: "portrait",
        },
        {
          image: p3,
          orientation: "portrait",
        },
        {
          image: p4,
          orientation: "portrait",
        },
        {
          image: p5,
          orientation: "portrait",
        },
        {
          image: p6,
          orientation: "portrait",
        },
        {
          image: p7,
          orientation: "portrait",
        },
        {
          image: p8,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "PUDRIJER",
        English: "PUDRIJER",
        Italian: "CIPRIA",
      },
      description: {
        Srpski:
          "Pastelni tonovi i zavodljive forme osnova su ove kolekcije koja prikazuje širok spektar koktel formi i dugih haljina u igri plemenitih tkanina, kombinujući ih sa dekorom od kristala i nojevog perja. Namenjena je ženi koja je samouverena i definisana u stilskom smislu. Ideja vodilja je objedinjavanje različitih povoda i prilika u kojima ova grupa odevnih komada pronalazi svoju primenu.",
        English:
          "Pastel tones and seductive forms are the basis of this collection which shows a wide range of cocktail forms and long dresses through a play of exquisite fabrics combined with a crystal décor and ostrich feathers. It is intended for a woman who is self-confident and defined with a sense of style. The guiding idea is to unify different causes and opportunities in which this group of garments finds its suitability.",
        Italian:
          "Le tonalità pastello e le forme seducenti rappresentano la base di questa collezione che comprende una vasta gamma di abiti da cocktail e vestiti lunghi inseriti in un gioco di tessuti nobili che vengono combinati con il decoro dei cristalli e le piume di struzzo. Questa linea è dedicata a una donna sicura di sé e definita nel senso dello stile. L’idea guida è la possibilità che questo gruppo di capi d’abbigliamento trovi la sua applicazione durante le varie occasioni e circostanze.",
      },
    },
    {
      title: {
        Srpski: "MONOGRAM",
        English: "MONOGRAM",
        Italian: "MONOGRAMMA",
      },
      photos: [
        {
          image: m1,
          orientation: "portrait",
        },
        {
          image: m2,
          orientation: "portrait",
        },
        {
          image: m5,
          orientation: "landscape",
        },
        {
          image: m3,
          orientation: "portrait",
        },
        {
          image: m4,
          orientation: "portrait",
        },
        {
          image: m6,
          orientation: "portrait",
        },
        {
          image: m7,
          orientation: "portrait",
        },
        {
          image: m8,
          orientation: "portrait",
        },
        {
          image: m9,
          orientation: "portrait",
        },
        {
          image: m10,
          orientation: "portrait",
        },
        {
          image: m11,
          orientation: "portrait",
        },
        {
          image: m12,
          orientation: "portrait",
        },
        {
          image: m13,
          orientation: "portrait",
        },
        {
          image: m14,
          orientation: "portrait",
        },
        {
          image: m15,
          orientation: "portrait",
        },
        {
          image: m16,
          orientation: "portrait",
        },
        {
          image: m17,
          orientation: "portrait",
        },
        {
          image: m18,
          orientation: "portrait",
        },
        {
          image: m19,
          orientation: "portrait",
        },
        {
          image: m20,
          orientation: "portrait",
        },
        {
          image: m21,
          orientation: "portrait",
        },
        {
          image: m22,
          orientation: "portrait",
        },
        {
          image: m23,
          orientation: "portrait",
        },
        {
          image: m24,
          orientation: "portrait",
        },
        {
          image: m25,
          orientation: "portrait",
        },
        {
          image: m26,
          orientation: "portrait",
        },
        {
          image: m27,
          orientation: "portrait",
        },
        {
          image: m28,
          orientation: "portrait",
        },
        {
          image: m29,
          orientation: "portrait",
        },
        {
          image: m30,
          orientation: "portrait",
        },
        {
          image: m31,
          orientation: "portrait",
        },
        {
          image: m32,
          orientation: "portrait",
        },
        {
          image: m33,
          orientation: "portrait",
        },
        {
          image: m34,
          orientation: "portrait",
        },
        {
          image: m35,
          orientation: "portrait",
        },
        {
          image: m36,
          orientation: "portrait",
        },
        {
          image: m37,
          orientation: "portrait",
        },
        {
          image: m38,
          orientation: "portrait",
        },
        {
          image: m39,
          orientation: "portrait",
        },
        {
          image: m40,
          orientation: "portrait",
        },
        {
          image: m41,
          orientation: "portrait",
        },
        {
          image: m42,
          orientation: "landscape",
        },
        {
          image: m43,
          orientation: "ladnscape",
        },
        {
          image: m44,
          orientation: "landscape",
        },
      ],
      text: {
        Srpski: "MONOGR",
        English: "MONOGR",
        Italian: "MONOGR",
      },
      description: {
        Srpski:
          "Kolekcija je omaž dizajnerovom iskustvu i obrazovanju u domenu grafike, izražena u interpretaciji zaštitnog logoa Ateljea. Monohromatska priča zamišljena je kao trag u vremenu i ukazuje na potrebu da se spoje dve grane umetnosti. U svojim konstrukcijskim rešenjima koketira sa nespojivim tkaninama i mnoštvom ručnih dorada koje u svakom, i najsitnijem elementu, asociraju na grafičko rešenje zaštitnog znaka Ateljea.",
        English:
          "The collection is homage to the designer’s experience and education in the domain of graphics, expressed in the interpretation of the Atelier’s protective logo. The monochrome story is conceived as a trace in time and indicates the need to join two branches of art. In its construction solutions, it flirts with incompatible fabrics and a plethora of handmade completionthat, in each andevery smallest segment, associate with the graphic solution of the Atelier’s trademark.",
        Italian:
          "La collezione rappresenta un omaggio all’esperienza e alla formazion del designer nell’ambito della grafica, espresso tramite l’interpretazione del marchio registrato dell’Atelier. Una storia monocromatica è stata ideata come un’impronta nel tempo e indica la necessità di unire due ambiti artistici. Nelle sue soluzioni costruttive civetta con dei tessuti disparati e moltissime finiture fatte a mano che in ogni elemento, persino quello più minuto, ricordano la soluzione grafica del marchio registrato dell’Atelier.",
      },
    },
    {
      title: {
        Srpski: "LITTLE BLUE DRESS LBD",
        English: "LITTLE BLUE DRESS LBD ",
        Italian: "LITTLE BLUE DRESS LBD",
      },
      photos: [
        {
          image: lbd1,
          orientation: "portrait",
        },
        {
          image: lbd2,
          orientation: "portrait",
        },
        {
          image: lbd3,
          orientation: "portrait",
        },
        {
          image: lbd4,
          orientation: "portrait",
        },
        {
          image: lbd5,
          orientation: "portrait",
        },
        {
          image: lbd6,
          orientation: "portrait",
        },
        {
          image: lbd7,
          orientation: "portrait",
        },
        {
          image: lbd8,
          orientation: "portrait",
        },
        {
          image: lbd9,
          orientation: "portrait",
        },
        {
          image: lbd10,
          orientation: "portrait",
        },
        {
          image: lbd11,
          orientation: "portrait",
        },
        {
          image: lbd12,
          orientation: "portrait",
        },
        {
          image: lbd13,
          orientation: "portrait",
        },
        {
          image: lbd14,
          orientation: "portrait",
        },
        {
          image: lbd15,
          orientation: "portrait",
        },
        {
          image: lbd16,
          orientation: "portrait",
        },
        {
          image: lbd17,
          orientation: "portrait",
        },
        {
          image: lbd18,
          orientation: "portrait",
        },
        {
          image: lbd19,
          orientation: "portrait",
        },
        {
          image: lbd20,
          orientation: "portrait",
        },
        {
          image: lbd21,
          orientation: "portrait",
        },
        {
          image: lbd22,
          orientation: "portrait",
        },
        {
          image: lbd23,
          orientation: "portrait",
        },
        {
          image: lbd24,
          orientation: "portrait",
        },
        {
          image: lbd25,
          orientation: "portrait",
        },
        {
          image: lbd26,
          orientation: "portrait",
        },
        {
          image: lbd27,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "LITTLE BL",
        English: "LITTLE BL",
        Italian: "LITTLE BL",
      },
      description: {
        Srpski:
          "Izazov koji je tim Ateljea postavio pred sobom bio je da u omiljenoj plavoj boji iznedri kolekciju koja će biti adekvatan odgovor na malu crnu haljinu. U kolekciji se nalazi veliki broj odevnih komada nastalih kao rezultat istraživanja tonova plave boje i tipova tkanine, koji od jutra do večeri mogu da nose naziv mala plava haljina.",
        English:
          "The challenge that the Atelier’s team set before them was to originate a collection in their favorite blue color that would be an adequate response to a little black dress.The collection contains a large number of garments made as a result of the research of blue tones and fabric types, which from the morning to the evening can be called alittle blue dress.",
        Italian:
          "Una sfida che il team dell’Atelier aveva stabilito era quella di generare una collezione nel suo colore preferito – il blu che dovrebbe corrispondere a un little black dress. Nella collezione ci sono molti capi d’abbigliamento nati come risultato della ricerca delle tonalità di blu e dei tipi di tessuti, che dalla mattina alla sera possono portare il nome del piccolo vestito blu.",
      },
    },
    {
      title: {
        Srpski: "ORIGAMI",
        English: "ORIGAMI",
        Italian: "ORIGAMI",
      },
      photos: [
        {
          image: o1,
          orientation: "portrait",
        },
        {
          image: o2,
          orientation: "portrait",
        },
        {
          image: o3,
          orientation: "portrait",
        },
        {
          image: o4,
          orientation: "portrait",
        },
        {
          image: o5,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "ORIGAMI",
        English: "ORIGAMI",
        Italian: "ORIGAMI",
      },
      description: {
        Srpski:
          "Ždral izrađen od papira u tehnici origamija bio je početna tačka ove kolekcije. Rešenja u formama, kao i koloriti, bili su usmereni na nasleđe Japana u njegovoj najširoj modnoj slici i ekstrovertnom shvatanju mode. Kolekcija obuhvata raznoliki, ali stilski ujednačen modni estetski koncept koji svoj izraz pronalazikroz rešenja za gornje i donje delove odeće.",
        English:
          "A Crane made of paper in the origami technique was the starting point of this collection.Solutions in shapes, as well as coloration, were focused on Japan’s heritage in its widest fashion scene and in extrovert fashion understanding.The collection includes a diverse but stylish, uniform fashion aesthetic concept that finds its expression through solutions for the upper and lower parts of the garment.",
        Italian:
          "La gru fatta di carta con la tecnica dell’origami è stata il punto iniziale di questa collezione. Le soluzioni nelle forme insieme al colorito traggono l’ispirazione dall’eredità giapponese nel senso più vasto della sua immagine della moda e nella percezione estroversa della moda. La collezione comprende il concetto estetico della moda di vario tipo, ma stilisticamente equilibrato che si esprime attraverso soluzioni per capi d’abbigliamento superiori e inferiori.",
      },
    },
    {
      title: {
        Srpski: "PRICELESS",
        English: "PRICELESS",
        Italian: "PRICELESS",
      },
      photos: [
        {
          image: pc1,
          orientation: "portrait",
        },
        {
          image: pc2,
          orientation: "portrait",
        },
        {
          image: pc3,
          orientation: "portrait",
        },
        {
          image: pc4,
          orientation: "portrait",
        },
        {
          image: pc5,
          orientation: "portrait",
        },
        {
          image: pc6,
          orientation: "portrait",
        },
        {
          image: pc7,
          orientation: "portrait",
        },
        {
          image: pc8,
          orientation: "portrait",
        },
        {
          image: pc9,
          orientation: "portrait",
        },
        {
          image: pc10,
          orientation: "portrait",
        },
        {
          image: pc11,
          orientation: "landscape",
        },
        {
          image: pc12,
          orientation: "portrait",
        },
        {
          image: pc13,
          orientation: "portrait",
        },
        {
          image: pc14,
          orientation: "portrait",
        },
        {
          image: pc15,
          orientation: "portrait",
        },
        {
          image: pc16,
          orientation: "portrait",
        },
        {
          image: pc17,
          orientation: "portrait",
        },
        {
          image: pc18,
          orientation: "portrait",
        },
        {
          image: pc19,
          orientation: "portrait",
        },
        {
          image: pc20,
          orientation: "portrait",
        },
        {
          image: pc21,
          orientation: "portrait",
        },
        {
          image: pc22,
          orientation: "portrait",
        },
        {
          image: pc23,
          orientation: "portrait",
        },
        {
          image: pc24,
          orientation: "portrait",
        },
        {
          image: pc25,
          orientation: "portrait",
        },
        {
          image: pc26,
          orientation: "portrait",
        },
        {
          image: pc27,
          orientation: "portrait",
        },
        {
          image: pc28,
          orientation: "portrait",
        },
        {
          image: pc29,
          orientation: "portrait",
        },
        {
          image: pc30,
          orientation: "portrait",
        },
        {
          image: pc31,
          orientation: "portrait",
        },
        {
          image: pc32,
          orientation: "portrait",
        },
        {
          image: pc33,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "PRICELES",
        English: "PRICELES",
        Italian: "PRICELESS",
      },
      description: {
        Srpski:
          "Godine koje su modu vodile ka onome što je danas bile su inspiracija za kolekciju pod nazivom Priceless. U estetici pedesetih godina prošlog veka pronađenesu forma i inspiracija. Priceless je kolekcija namenjena luksuznoj, raskošnoj i bogato stilizovanoj ženi koja odiše elementima stila novog veka, na čijem je modnom nasleđu kolekcija nastala.",
        English:
          "The years that led the fashion to what it is today were the inspiration for the collection called Priceless. In the aesthetics of the fifties of the last century, form and inspiration were found. Priceless is a collection intended for a luxurious, lavish and opulently styled woman who reflects the fashionable elements of a new century, on whose fashion heritage the collection originated.",
        Italian:
          "Gli anni che hanno portato la moda verso quello che è oggi sono stati l’ispirazione per la collezione denominata Priceless. La forma e l’ispirazione sono state trovate nell’estetica degli anni cinquanta. La collezione Priceless è destinata alla donna lussuosa, fastosa e riccamente stilizzata che emana elementi dello stile del nuovo secolo, la cui eredità nella moda è stata il punto cardine di questa collezione.",
      },
    },
    {
      title: {
        Srpski: "CRUISE",
        English: "CRUISE",
        Italian: "CRUISE",
      },
      photos: [
        {
          image: c1,
          orientation: "portrait",
        },
        {
          image: c2,
          orientation: "portrait",
        },
        {
          image: c3,
          orientation: "portrait",
        },
        {
          image: c4,
          orientation: "portrait",
        },
        {
          image: c5,
          orientation: "portrait",
        },
        {
          image: c6,
          orientation: "portrait",
        },
        {
          image: c7,
          orientation: "portrait",
        },
        {
          image: c8,
          orientation: "portrait",
        },
        {
          image: c9,
          orientation: "portrait",
        },
        {
          image: c10,
          orientation: "portrait",
        },
        {
          image: c11,
          orientation: "portrait",
        },
        {
          image: c12,
          orientation: "portrait",
        },
        {
          image: c13,
          orientation: "portrait",
        },
        {
          image: c14,
          orientation: "portrait",
        },
        {
          image: c15,
          orientation: "portrait",
        },
        {
          image: c16,
          orientation: "portrait",
        },
        {
          image: c17,
          orientation: "portrait",
        },
        {
          image: c18,
          orientation: "portrait",
        },
        {
          image: c19,
          orientation: "portrait",
        },
        {
          image: c20,
          orientation: "portrait",
        },
        {
          image: c21,
          orientation: "portrait",
        },
        {
          image: c22,
          orientation: "portrait",
        },
        {
          image: c23,
          orientation: "portrait",
        },
        {
          image: c24,
          orientation: "portrait",
        },
        {
          image: c25,
          orientation: "portrait",
        },
        {
          image: c26,
          orientation: "portrait",
        },
        {
          image: c27,
          orientation: "portrait",
        },
        {
          image: c28,
          orientation: "portrait",
        },
        {
          image: c29,
          orientation: "portrait",
        },
        {
          image: c30,
          orientation: "portrait",
        },
        {
          image: c31,
          orientation: "portrait",
        },
        {
          image: c32,
          orientation: "portrait",
        },
        {
          image: c33,
          orientation: "portrait",
        },
        {
          image: c34,
          orientation: "portrait",
        },
        {
          image: c35,
          orientation: "portrait",
        },
        {
          image: c36,
          orientation: "portrait",
        },
        {
          image: c37,
          orientation: "portrait",
        },
        {
          image: c38,
          orientation: "portrait",
        },
        {
          image: c39,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "CRUISE",
        English: "CRUISE",
        Italian: "CRUISE",
      },
      description: {
        Srpski:
          "Kolekcija Cruise predstavlja malo modno putovanje koje obiluje prugama i bojama, asocirajući na trenutke odmora. U okviru kolekcije prikazani su modeli koji od jutra do večeri mogusvojim savremenim, ali stilski pojavnim modnim izrazom zadovoljiti najrazličitije povode i prilike. Pojava džinsa, kao i delovi kolekcije izrađeni od poni dlake,otvaraju ovu kolekciju ka brojnim namenama.",
        English:
          "The Cruise Collection is a small fashionable journey that abounds with lines and colors, reflecting moments of a holiday.Within the presented collection are items that can accommodate the most varied occasions and opportunities with their modern, yet stylish fashionable expression in appearance, from the morning to the evening. The presence of the jeans, as well as parts of the collection made from pony hairs, make this collection adequate for numerous purposes.",
        Italian:
          "La collezione Cruise rappresenta un piccolo viaggio nella moda che pullula di strisce e colori, che ricordano i momenti di vacanza. All’interno della collezione trovano posto i modelli che dalla mattina alla sera possono soddisfare le più varie occasioni ed eventi con la loro contemporanea, ma stilisticamente appariscente espressione della moda. La presenza del jeans, nonché le parti della collezione fatte in pelo di pony, rivelano delle maggiori possibilità di utilizzo di questa collezione.",
      },
    },
    {
      title: {
        Srpski: "MED I MLEKO",
        English: "MILK AND HONEY",
        Italian: "MIELE E LATTE",
      },
      photos: [
        {
          image: mm1,
          orientation: "portrait",
        },
        {
          image: mm2,
          orientation: "portrait",
        },
        {
          image: mm3,
          orientation: "portrait",
        },
        {
          image: mm4,
          orientation: "portrait",
        },
        {
          image: mm5,
          orientation: "portrait",
        },
        {
          image: mm6,
          orientation: "portrait",
        },
        {
          image: mm7,
          orientation: "portrait",
        },
        {
          image: mm8,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "MED I ML",
        English: "MILK AN",
        Italian: "MIELE E ",
      },
      description: {
        Srpski:
          "Etno-nasleđe Šumadije polazište je kolekcije u kojoj je kolorit originalne estetike pažljivo zamenjen bojama meda, zlata i belom bojom. Svaki komad obiluje detaljima muške i ženske narodne nošnje zapadne Srbije. Višesatni ručni rad na svakom komadu bio je neophodan pri stvaranju Meda i mleka, a kao spona između svetskog i lokalnog nasleđa javlja se ruža, glavni motiv koji se u detaljima provlači kroz čitavu koleciju.",
        English:
          "The ethno-heritage of Šumadija is the starting point of a collection in which the coloration of original aesthetics is carefully replaced with honey, gold and white colors. Each item abounds with the details of male and female national costumes of Western Serbia. Multiple handmade completions on every item was necessary in the creation of Milk and Honey, and as a bond between the world heritage and the local heritage, there is a rose, the main motif, which is pervading through the whole collection.",
        Italian:
          "L’etno-eredità della zona della Šumadija è stata il punto di partenza di questa collezione in cui il colorito dell’estetica originale è stato accuratamente cambiato dai colori di miele, oro e bianco. Ogni capo abbonda di dettagli presenti sui costumi folkloristici maschili e femminili provenienti dalla Serbia occidentale. Il lavoro a mano su ogni capo che è durato per ore è stato necessario durante il processo creativo della linea Miele e latte, mentre in veste del legame tra l’eredità mondiale e quella nazionale appare la rosa, il motivo principale presente nei dettagli dell’intera collezione.",
      },
    },
    {
      title: {
        Srpski: "BUTTERFLY",
        English: "BUTTERFLY",
        Italian: "BUTTERFLY",
      },
      photos: [
        {
          image: b1,
          orientation: "portrait",
        },
        {
          image: b2,
          orientation: "portrait",
        },
        {
          image: b7,
          orientation: "landscape",
        },
        {
          image: b3,
          orientation: "portrait",
        },
        {
          image: b4,
          orientation: "portrait",
        },
        {
          image: b8,
          orientation: "landscape",
        },
        {
          image: b5,
          orientation: "portrait",
        },
        {
          image: b6,
          orientation: "portrait",
        },
        {
          image: b9,
          orientation: "portrait",
        },
        {
          image: b10,
          orientation: "portrait",
        },
        {
          image: b11,
          orientation: "portrait",
        },
        {
          image: b12,
          orientation: "portrait",
        },
        {
          image: b13,
          orientation: "portrait",
        },
        {
          image: b14,
          orientation: "portrait",
        },
        {
          image: b15,
          orientation: "portrait",
        },
        {
          image: b16,
          orientation: "portrait",
        },
        {
          image: b17,
          orientation: "portrait",
        },
        {
          image: b18,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "BUTTERFL",
        English: "BUTTERFL",
        Italian: "BUTTERFL",
      },
      description: {
        Srpski:
          "Igra leptira i formi koje asociraju na detalje iz prirode, kao i boje i sjaj predela koji su bili inspiracija za ovu kolekciju, čine odevne komade lepršavim, ali konstrukcijski tačnim i primenljivim u brojnim prilikama. Istraživanje je bilo naročito usmereno na formu preklopa i vezivanja u mnoštvu odevnih komada.",
        English:
          "The butterfly’s dance and shapes that associate with details from nature, as well as the colors and glow of the lands that have been the inspiration for this collection, make the garments vibrant, but structurally correct and appropriate for numerous occasions. The research was especially oriented towards the wrapping and binding forms presented in numerous garments.",
        Italian:
          "La danza di farfalla e forme che assomigliano ai dettagli della natura, insieme ai colori e alla luminosità dei paesaggi che hanno ispirato questa collezione, rendono questi capi d’abbigliamento sventolanti, ma costruttivamente precisi e utilizzabili in varie circostanze. La ricerca è stata soprattutto orientata verso la forma della piegatura e dell’allacciatura nei vari capi d’abbigliamento.",
      },
    },
    {
      title: {
        Srpski: "BLACK",
        English: "BLACK",
        Italian: "BLACK",
      },
      photos: [
        {
          image: blck1,
          orientation: "portrait",
        },
        {
          image: blck2,
          orientation: "portrait",
        },
        {
          image: blck3,
          orientation: "portrait",
        },
        {
          image: blck4,
          orientation: "portrait",
        },
        {
          image: blck5,
          orientation: "portrait",
        },
        {
          image: blck6,
          orientation: "portrait",
        },
        {
          image: blck7,
          orientation: "portrait",
        },
        {
          image: blck8,
          orientation: "portrait",
        },
        {
          image: blck9,
          orientation: "portrait",
        },
        {
          image: blck10,
          orientation: "portrait",
        },
        {
          image: blck11,
          orientation: "portrait",
        },
        {
          image: blck12,
          orientation: "portrait",
        },
        {
          image: blck13,
          orientation: "portrait",
        },
        {
          image: blck14,
          orientation: "portrait",
        },
        {
          image: blck15,
          orientation: "portrait",
        },
        {
          image: blck16,
          orientation: "portrait",
        },
        {
          image: blck17,
          orientation: "portrait",
        },
        {
          image: blck18,
          orientation: "portrait",
        },
        {
          image: blck19,
          orientation: "portrait",
        },
        {
          image: blck20,
          orientation: "portrait",
        },
        {
          image: blck21,
          orientation: "portrait",
        },
        {
          image: blck22,
          orientation: "portrait",
        },
        {
          image: blck23,
          orientation: "portrait",
        },
        {
          image: blck24,
          orientation: "portrait",
        },
        {
          image: blck25,
          orientation: "portrait",
        },
        {
          image: blck26,
          orientation: "portrait",
        },
        {
          image: blck27,
          orientation: "portrait",
        },
        {
          image: blck28,
          orientation: "portrait",
        },
        {
          image: blck29,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "BLACK",
        English: "BLACK",
        Italian: "BLACK",
      },
      description: {
        Srpski:
          "Prva kolekcija koju je Atelje prikazao inspirisana je linijom kao osnovnim principom i polazištem. Linija je početak svakog crteža, pa tako i ova kolekcija predstavlja početak modnog putovanja na koje je Atelje pozvao sve one ljubitelje mode koji su prepoznali put Atelja kao sopstveni.",
        English:
          "The first collection presented by the Atelier is inspired by the line as a basic principle and as a starting point. The line is the beginning of every drawing; therefore this collection represents the beginning of a fashion journey to which the Atelier invited all those fashion devotees who recognized the way of Atelier as their own.",
        Italian:
          "La prima collezione presentata dall’Atelier è ispirata dalla linea, come principio di base e punto di partenza. La linea è l’inizio di ogni disegno e quindi anche questa collezione rappresenta l’inizio di un viaggio nella moda a cui l’Atelier ha invitato tutti gli amanti della moda che hanno riconosciuto il percorso dell’Atelier come proprio.",
      },
    },
    {
      title: {
        Srpski: "MERLETTO",
        English: "MERLETTO",
        Italian: "MERLETTO",
      },
      photos: [
        {
          image: ml1,
          orientation: "portrait",
        },
        {
          image: ml2,
          orientation: "portrait",
        },
        {
          image: ml3,
          orientation: "portrait",
        },
        {
          image: ml4,
          orientation: "portrait",
        },
        {
          image: ml5,
          orientation: "portrait",
        },
        {
          image: ml6,
          orientation: "portrait",
        },
        {
          image: ml7,
          orientation: "portrait",
        },
        {
          image: ml8,
          orientation: "portrait",
        },
        {
          image: ml9,
          orientation: "portrait",
        },
        {
          image: ml10,
          orientation: "portrait",
        },
        {
          image: ml11,
          orientation: "portrait",
        },
        {
          image: ml12,
          orientation: "portrait",
        },
        {
          image: ml13,
          orientation: "portrait",
        },
        {
          image: ml14,
          orientation: "portrait",
        },
        {
          image: ml15,
          orientation: "portrait",
        },
        {
          image: ml16,
          orientation: "portrait",
        },
        {
          image: ml17,
          orientation: "portrait",
        },
        {
          image: ml18,
          orientation: "portrait",
        },
        {
          image: ml19,
          orientation: "portrait",
        },
        {
          image: ml20,
          orientation: "portrait",
        },
        {
          image: ml21,
          orientation: "portrait",
        },
        {
          image: ml22,
          orientation: "portrait",
        },
        {
          image: ml23,
          orientation: "portrait",
        },
        {
          image: ml24,
          orientation: "portrait",
        },
        {
          image: ml25,
          orientation: "portrait",
        },
      ],
      text: {
        Srpski: "MERLETTO",
        English: "MERLETTO",
        Italian: "MERLETTO",
      },
      description: {
        Srpski:
          "Venčanice su trajna inspiracija jer se radi o haljinama koje obično bivaju posebne i pažljivo birane. Da bismo odgovorili na zahtev brojnih klijenata koji su želeli liniju ready to wear venčanica, pokrenuta je linija Merletto koja nudi brojna rešenja u okviru modne estetike koju Atelje neguje.",
        English:
          "Wedding dresses are an everlasting inspiration because they are dresses that are usually particularly and carefully selected. In order to respond to the demand of many customers who wanted ready-to-wear wedding line, the Merletto line has been launched so that it offers numerous solutions in the fashion aesthetics which the Atelier nourishes.",
        Italian:
          "Gli abiti da sposa sono un’eterna ispirazione perchè si tratta di abiti che normalmente sono speciali e scelti con molta cura. Per poter rispondere alle richieste dei numerosi clienti che desideravano una linea di abiti da sposa ready to wear, abbiamo lanciato la linea Merletto che offre numerose soluzioni all’interno dell’estetica della moda curata dall’Atelier.",
      },
    },
  ],
  collectionsList: [
    {
      name: {
        Srpski: "Blooming",
        English: "Blooming",
        Italian: "Blooming",
      },
      image: bloomMain,
    },
    {
      name: {
        Srpski: "Diva",
        English: "Diva",
        Italian: "Diva",
      },
      image: divaMain,
    },
    {
      name: {
        Srpski: "Karlneval",
        English: "Karlneval",
        Italian: "Karlneval",
      },
      image: karlMain,
    },
    {
      name: {
        Srpski: "Secret garden",
        English: "Secret garden",
        Italian: "Secret garden",
      },
      image: ten,
    },
    {
      name: {
        Srpski: "Avenue foch",
        English: "Avenue foch",
        Italian: "Avenue foch",
      },
      image: eleven,
    },
    {
      name: {
        Srpski: "Pudrijera",
        English: "Pudrijera",
        Italian: "CIPRIA",
      },
      image: twelve,
    },
    {
      name: {
        Srpski: "Monogram",
        English: "Monogram",
        Italian: "Monogramma",
      },
      image: therteen,
    },
    {
      name: {
        Srpski: "Little blue dress",
        English: "Little blue dress lbd",
        Italian: "LITTLE BLUE DRESS LBD",
      },
      image: fourteen,
    },
  ],
  ContactInfoFirst: {
    text: {
      Srpski: "RADNJA",
      English: "STORE",
      Italian: "NEGOZIO",
    },
    photo: fifteen,
    photo2: sivepozadine,
    photo3: store,
    title: {
      Srpski: "RADNJA",
      English: "STORE",
      Italian: "NEGOZIO",
    },
    subtitle: "Kralja Petra 36",
    subtitle2: {
      Srpski: "Beograd",
      English: "Belgrade",
      Italian: "Belgrado",
    },
    description: {
      Srpski: "Radno vreme",
      English: "Working hours",
      Italian: "Travahale hura",
    },
    description2: {
      Srpski: "Pon-Pet 12h-20h",
      English: "Mon-Fri 12h-20h",
      Italian: "Mon-Fri 12h-20h",
    },
    description3: {
      Srpski: "Sub 10h-16h",
      English: "Sat 10h-16h",
      Italian: "Sat 10h-16h",
    },
  },
  ContactInfoSecond: {
    text: {
      Srpski: "ATELJE",
      English: "ATELIER",
      Italian: "ATELIER",
    },
    photo: sixteen,
    photo2: sivepozadine,
    photo3: atelier,
    title: {
      Srpski: "ATELJE",
      English: "ATELIER",
      Italian: "ATELIER",
    },
    subtitle: "Lamartinova 23",
    subtitle2: {
      Srpski: "Beograd",
      English: "Belgrade",
      Italian: "Belgrado",
    },
  },
  DesignerInfo: {
    title: "IGOR",
    photo: nine,
    photo3: igormain2,
    text: "IGOR",
    subtitle: {
      Srpski: "TODOROVIĆ",
      English: "TODOROVIĆ",
      Italian: "TODOROVIĆ",
    },
    description: {
      Srpski: "O dizajneru",
      English: "The designer",
      Italian: "Designer",
    },
    description2: {
      Srpski:
        "Igor Todorović je rođen u Beogradu. Od malena usmeren ka svetu umetnosti i okružen njime, završava srednju dizajnersku školu, smer grafika. Spletom okolnosti nastavlja da gradi svoj umetnički izraz na studijama modnog dizajna u Italiji. Uspešno završava Akademiju visoke mode Koefia u Rimu. Tokom studija učestvuje na brojnim takmičenjima i dobija nagrade za svoj rad. Povratak u Beograd obeležilo je stvaranje brenda obuće Joshua, koju dizajnira nekoliko godina. Zainteresovan za svet medija, svoju profesionalnu karijeru nastavlja kao prvi srpski modni urednik magazina Man’s Health i Cosmopolitan. Po osnivanju Fashion TV kanala za jugoistočnu Evropu preuzima ulogu glavnog i odgovornog urednika i realizuje brojne sadržaje. Za rad u medijima dobio je brojna priznanja i nagrade. Nakon toga, vraća se u modni svet pokretanjem sopstvenog brenda koji od tada brižljivo neguje i razvija. Često kaže da se oseća privilegovano jer je okružen saradnicima i klijentima koji poštuju odevne komade sa njegovim potpisom.",
      English:
        "Igor Todorovic was born in Belgrade. From an early age oriented towards the world of art and surrounded by it, he finishes the High school of Design, major in graphic design. With a variety of circumstances he continues to build his artistic expression through fashion design studies in Italy. Successfully finishes the High Fashion Koefia Academy in Rome. During the studies he participates in numerous competitions and receives awards for his work. Returning to Belgrade he leaves a mark by creating a shoe brand, Joshua, which he designed for several years. Interested in the world of media, he continues his professional career as the first Serbian fashion editor of the magazine Man’s Health and Cosmopolitan. After the founding of the Fashion TV channel for Southeast Europe, he takes over the role of editor-in-chief and carries out numerous contents. For his work in media he receives various recognitions and awards. Afterwards, he returns to the fashion world by starting his own brand which he has been carefully nurturing and developing since. He often says he feels privileged because he is surrounded by associates and clients who respect the garments with his signature.",
      Italian:
        "Igor Todorović è nato a Belgrado. Siccome fin da piccolo era orientato verso il mondo della moda e circondato da questa atmosfera, si diploma presso il liceo artistico, indirizzo grafico. Successivamente, grazie a una serie di circostanze, continua a formare la propria espressione artistica durante gli studi di design della moda in Italia. Si laurea con successo all’Accademia d’Alta Moda e d’Arte del Costume Koefia a Roma. Durante gli studi partecipa a numerose competizioni e viene premiato per il suo lavoro. Il ritorno a Belgrado viene segnato dal lancio del marchio di scarpe Joshua che esiste ormai da alcuni anni. Interessato al mondo dei media, la sua carriera professionale continua presso le riviste Man’s Health e Cosmopolitan nel ruolo del primo fashion editor serbo. Dopo il lancio del canale Fashion TV per l’Europa sud-orientale, ricopre il ruolo dell’editor-in-chief e realizza vari contenuti. Per il suo impegno nei media ha ricevuto vari riconoscimenti e premi. Dopo questa esperienza fa ritorno al mondo della moda lanciando il proprio marchio che, da allora, cura e sviluppa accuratamente. Spesso dice di sentirsi privilegiato essendo circondato da collaboratori e clienti che rispettano i capi d’abbigliamento con la sua firma.",
    },
    description3: {
      Srpski:
        "Među njegovim klijentima u dosadašnjem radu našle su se brojne ličnosti iz različitih sfera društvenog života. Takođe, učestvovao je i na mnogim projektima. Svaka kolekcija za njega je izazov i određena modna poruka, koja dopire i do brojnih klijenata van Srbije, gde Atelje stvara i radi. Okrenut budućnosti i novim izazovima, svakom novom kolekcijom je za još jednu stepenicu bliži ostvarenju ciljeva koje je pred sobom postavio.",
      English:
        "In his work thus far he gained numerous clients from different spheres of social life. He also participated in many projects. Every collection for him is a challenge and a stated fashion message that also reaches various clients outside of Serbia, where the Atelier creates and works. Looking towards the future and facing new challenges, each new collection is another step closer to achieving the goals set before him.",
      Italian:
        "Nel corso della sua carriera, tra i suoi clienti incontriamo molti personaggi che provengono da diverse realtà sociali. Inoltre, ha partecipato a numerosi progetti. Ogni collezione per lui rappresenta una sfida e trasmette un certo messaggio della moda, raggiungendo anche vari clienti al di fuori della Serbia, dove si trova la sede dell’Atelier. Orientato verso il futuro e verso le nuove sfide, ogni nuova collezione lo porta a un passo più vicino alla realizzazione degli obiettivi che aveva stabilito.",
    },
  },

  AtelierInfoFirst: {
    title: {
      Srpski: "ATELJE",
      English: "ATELIER",
      Italian: "ATELIER",
    },
    video: videoAtelier,
    text: {
      Srpski: "ATELJE",
      English: "ATELIER",
      Italian: "ATELIER",
    },
    subtitle: {
      Srpski: "IGOR TODOROVIĆ",
      English: "IGOR TODOROVIĆ",
      Italian: "IGOR TODOROVIĆ",
    },
    description: {
      Srpski: "Atelje i radionica",
      English: "Atelier and workshop",
      Italian: "Atelier and workshop",
    },
  },
  AtelierInfoSecond: {
    photo: skice,
    description: {
      Srpski:
        "Lepota žene i njena autentična atmosfera su večita inspiracija.\nAtelje „Igor Todorovićˮ osnovan je sa ciljem da neguje i uspostavi autentičnu, samosvesnu i ženstvenu siluetu u kojoj će svaka žena moći da pronađe svoj stil. Stvoren kao custom made koncept, tim Ateljea je uvek okrenut detaljima, pažljivoj i promišljenoj konstrukciji i doradama koje svaki komad našeg ateljea čine jedinstvenim. Negujući svoj estetski princip, Atelje je razvio i kolekciju venčanica Merletto, kao i liniju koja je namenjena široj publici – Deconstructed. Modni put trasiran je kao stalno istraživanje forme, tkanine i kolorita, a ostvaruje se kroz stalni dijalog sa ljubiteljima našeg estetskog principa.",
      English:
        "A woman’s beauty and the aura of her authenticity is everlasting inspiration.\nAtelier “Igor Todorovic” was founded with a purpose to nurture and to establish authentic, self-aware and feminine silhouette in which every woman will be able to find her own style. Created as a custom made concept, the Atelier’s Team is always oriented towards details, careful and thoughtful construction and completion that make every item of our Atelier unique. By nurturing our own aesthetic principle, the Atelier has developed a wedding line, Merletto, as well as the line designed for a wider audience- Deconstructed. A fashion path paved as a continuous search of form, fabric and coloration, is accomplished through repeated dialog with devotees of our aesthetic principle.",
      Italian:
        'La bellezza femminile e la sua atmosfera autentica da sempre sono fonte di ispirazione.\nL’atelier "Igor Todorovićˮ è stato fondato con l’obiettivo di curare e definire una silhouette autentica, consapevole e femminile in cui ogni donna potrà riconoscere il proprio stile. Creato secondo il concetto custom made, il team dell’Atelier presta sempre attenzione ai dettagli, a una meticolosa e ben congeniata costruzione e alle rifiniture che rendono ogni pezzo del nostro Atelier unico. Tenendo conto del proprio principio estetico, l’Atelier ha inoltre sviluppato una linea di abiti da sposa Merletto, insieme ad una linea destinata a un pubblico più vasto – Deconstructed. Il cammino della moda è dettato da una ricerca continua della forma, dei tessuti e del colorito e viene realizzato attraverso un dialogo costante con gli amanti del nostro principio estetico.',
    },
  },
  AtelierInfoThird: {
    photo: ateliermain,
    photo3: radionica,
    text: {
      Srpski: "RADIONICA",
      English: "WORKSHOP",
      Italian: "IL LABOR",
    },
    title: {
      Srpski: "RADIONICA",
      English: "WORKSHOP",
      Italian: "IL LABORATORIO",
    },
    subtitle: {
      Srpski: "IGOR TODOROVIĆ",
      English: "IGOR TODOROVIĆ",
      Italian: "IGOR TODOROVIĆ",
    },
    desc: {
      Srpski: "O radionici",
      English: "About workshop",
      Italian: "riguardo al workshop",
    },
    description: {
      Srpski:
        "Radionica je DNK jednog modnog ateljea. Svi mi smo deo tog lanca povezanog u stalnoj potrazi za idealnom tkaninom, prostudiranim krojem, adekvatnim detaljem, najfinijom ručnom doradom... A tu je još bezbroj malih tajni koje brižljivo čuvamo. To je mesto gde u svakom komadu koji tu nastane tragamo za zlatnim presekom i harmonijom. Svakog dana analiziramo ukuse i trendove koji se u modi menjaju i sledimo pravila i definicije dobrog ukusa i stila odevanja. Tu se nalazi bezbroj krojeva za koje smo lično uzimali mere. Tu smo stvarali i tu stvaramo našu malu magijukojom želimo da začaramo živote naših dragih klijenata, čije poverenje i lojalnost doživljavamo kao veliku privilegiju. Radionica je izvor kreativne energije i mesto gde zlatne ruke naših majstora stvaraju naš modni trag u vremenu.",
      English:
        "Workshop is the DNA of a fashion atelier. We are all part of that chain connected with a constant search for an ideal fabric, studied form, adequate details, the finest handmade completion... And there are countless little secrets that we carefully guard. It is the place where in every item that arises, we seek for a golden cross-section and a harmony. Every day we analyze the tastes and trends that are changing in fashion and follow the rules and definitions of a good taste and style of attire. There are countless forms for which we personally took measures. It is a place we have created and create our petite magic with which we want to enchant the lives of our dear clients, whose trust and loyalty we perceive as a great privilege. The workshop is a source of creative energy and a place where the golden hands of our masters create our fashion trail in time.",
      Italian:
        "Il laboratorio rappresenta il DNA di un atelier della moda. Tutti noi facciamo parte di questa catena, uniti nella ricerca continua di un tessuto ideale, di un taglio ben studiato, di un dettaglio adeguato, di una rifinitura a mano più raffinata... E inoltre, ci sono innumerevoli piccoli segreti che teniamo per noi. Si tratta del posto dove in ogni capo che viene creato, cerchiamo la sezione d’oro e l’armonia. Ogni giorno analizziamo i gusti e le tendenze che nella moda cambiano, seguendo le regole e definizioni di buon gusto e stile nell’abbigliamento. Vi si trovano migliaia di tagli per i quali abbiamo preso personalmente le misure e in questo posto abbiamo creato e stiamo creando la nostra piccola magia con la quale vogliamo incantare le vite dei nostri carissimi clienti, la cui fiducia e lealtà rappresenta per noi un grande privilegio. Il laboratorio è la fonte dell’energia creativa e il luogo dove le mani d’oro dei nostri sarti lasciano le nostre impronte della moda nel tempo.",
    },
  },
  LatestFSInfo: {
    title: {
      Srpski: "NOVA",
      English: "NEW",
      Italian: "NUOVA",
    },
    photo: bloomCover,
    photo2: sivepozadine,
    photo3: bloomCover,
    text: "BLOOMIN",
    subtitle: {
      Srpski: "KOLEKCIJA",
      English: "COLLECTION",
      Italian: "COLLEZIONE",
    },
    description: "Blooming",
    ctaLatest: {
      Srpski: "Pogledaj kolekciju",
      English: "View more",
      Italian: "Scopri di più",
    },
  },
  homeVideo: {
    title: {
      Srpski: "POGLEDAJTE!",
      English: "CHECK IT OUT!",
      Italian: "SCORPI DI PIU",
    },
    titleBig: {
      Srpski: "VIDEO SA NAŠE REVIJE",
      English: "VIDEO FROM OUR SHOW",
      Italian: "VIDEO DEL NOSTRO RIVISTA",
    },
    description: {
      Srpski: "Kulturno umetničko društvo Ivo Lola Ribar 2019",
      English: "Kulturno umetničko društvo Ivo Lola Ribar 2019",
      Italian: "Kulturno umetničko društvo Ivo Lola Ribar 2019",
    },
    video: Lora,
  },
  fullScreenInfoOne: {
    title: {
      Srpski: "IGOR TODOROVIĆ",
      English: "IGOR TODOROVIĆ",
      Italian: "IGOR TODOROVIĆ",
    },
    photo: igormain,
    photo3: igormain,
    text: "IGORTOD",
    subtitle: {
      Srpski: "Priča o dizajneru",
      English: "Story about designer",
      Italian: "Storia del designer",
    },
    description: {
      Srpski:
        "Igor Todorović je rođen u Beogradu. Od malena usmeren ka svetu umetnosti i okružen njime, završava srednju dizajnersku školu, smer grafika. Spletom okolnosti nastavlja da gradi svoj umetnički izraz na studijama modnog dizajna u Italiji. Uspešno završava Akademiju visoke mode Koefia u Rimu...",
      English:
        "Igor Todorovic was born in Belgrade. From an early age oriented towards the world of art and surrounded by it, he finishes the High school of Design, major in graphic design. With a variety of circumstances he continues to build his artistic expression through fashion design studies in Italy. Successfully finishes the High Fashion Koefia Academy in Rome...",
      Italian:
        "Igor Todorović è nato a Belgrado. Siccome fin da piccolo era orientato verso il mondo della moda e circondato da questa atmosfera, si diploma presso il liceo artistico, indirizzo grafico. Successivamente, grazie a una serie di circostanze, continua a formare la propria espressione artistica durante gli studi di design della moda in Italia. Si laurea con successo all’Accademia d’Alta Moda e d’Arte del Costume Koefia a Roma...",
    },
    ctaFull: {
      Srpski: "Saznaj više",
      English: "Read more",
      Italian: "Scopri di più",
    },
  },
  fullScreenInfoTwo: {
    title: {
      Srpski: "ATELJE",
      English: "ATELIER",
      Italian: "ATELIER",
    },
    photo: ateliermain,
    photo3: ateliermain,
    text: {
      Srpski: "ATELJE",
      English: "ATELIER",
      Italian: "ATELIER",
    },
    subtitle: {
      Srpski: "Iza kulisa",
      English: "Behind the scenes",
      Italian: "dietro le quinte",
    },
    description: {
      Srpski:
        "Lepota žene i njena autentična atmosfera su večita inspiracija. Atelje „Igor Todorovićˮ osnovan je sa ciljem da neguje i uspostavi autentičnu, samosvesnu i ženstvenu siluetu u kojoj će svaka žena moći da pronađe svoj stil...",
      English:
        "A woman’s beauty and the aura of her authenticity is everlasting inspiration. Atelier “Igor Todorovic” was founded with a purpose to nurture and to establish authentic, self-aware and feminine silhouette in which every woman will be able to find her own style...",
      Italian:
        'La bellezza femminile e la sua atmosfera autentica da sempre sono fonte di ispirazione. L’atelier "Igor Todorovićˮ è stato fondato con l’obiettivo di curare e definire una silhouette autentica, consapevole e femminile in cui ogni donna potrà riconoscere il proprio stile...',
    },
    ctaFull2: {
      Srpski: "Saznaj više",
      English: "Read more",
      Italian: "Scopri di più",
    },
  },
  homeCollections: [
    {
      title: {
        Srpski: "DECONSTRUCTED",
        English: "DECONSTRUCTED",
        Italian: "DECONSTRUCTED",
      },
      photo1: dc5,
      photo2: dc19,
      text: "DECONS",
      description: {
        Srpski:
          "Kolekcija je konstruisana dekonstrukcija nove street wear linije u gami modnog potpisa Ateljea „Igor Todorovićˮ. Ovaj koncept osmislili smo za aktivnu, atraktivnu i aktualnu ženu koja u njemu može da pronađe svoj stil, i to na lak i dostupan način, iz sezone u sezonu. Cilj nam je da iz naziva Deconstructed zajedno konstruišemo estetiku u kojoj ćete uživati.",
        English:
          "The collection is constructed deconstruction of the new street wear line in the fashion signature of the Atelier “Igor Todorović”. We have designed this concept for an active, attractive and contemporary woman who can find her style in an easy and accessible way, from season to season. Our aim is to design together, out of the name Deconstructed, an aesthetic in which you will enjoy.",
        Italian:
          'La collezione è una decostruzione costruita della nuova linea street wear che fa parte della gamma dei capi che portano la firma dell’Atelier "Igor Todorovićˮ. Questo concetto è stato ideato per una donna attiva, attraente e attuale che si può riconoscere nello stile della collezione in un modo facile e accessibile, da stagione a stagione. Il nostro scopo è costruire insieme un’estetica dal nome Deconstructed che vi piacerà.',
      },
    },
    {
      title: {
        Srpski: "SECRET GARDEN",
        English: "SECRET GARDEN",
        Italian: "SECRET GARDEN",
      },
      photo1: sg4,
      photo2: sgHome3,
      text: "SECRE",
      description: {
        Srpski:
          "Kolekcija Secret Garden manifest je tajanstvenosti ženske siluete, zavijene u brižljivo izrađene i rukom dorađene elemente koji asociraju na bršljan. Izbor tkanina i konstrukcijska rešenja dosledni su potpisu Ateljea i usmereni su na inovaciju, ali ujedno i inspirišu ženu koja želi da bude autentična i zavodljiva kroz bajkoviti svet tajanstvenog vrta modne priče nastale kroz ovu kolekciju.",
        English:
          "The collection Secret Garden is a manifest of enigmatic woman’s silhouette, wrapped in carefully crafted and hand-made elements that relate to ivy. The choice of fabric and construction solution are consistent with Atelier’s signature that is also focused on innovation and at the same time it inspires a woman who wishes to be authentic and seductive through the fairy tale world of mysterious garden within a fashion story formed through this collection.",
        Italian:
          "La collezione Secret Garden rappresenta il manifesto del mistero della silhouette femminile, avvolta in elementi accuratamente realizzati e rifiniti a mano che ricordano l’edera. La scelta dei tessuti e le soluzioni costruttive rispettano la firma dell’Atelier e sono orientati verso l’innovazione, ispirando allo stesso tempo la donna che mira ad essere autentica e seducente attraverso questo fantasioso mondo del giardino misterioso inserito nella storia della moda che è nata in questa collezione.",
      },
    },
    {
      title: {
        Srpski: "AVENUE FOCH",
        English: "AVENUE FOCH",
        Italian: "AVENUE FOCH",
      },
      photo1: afHome2,
      photo2: afHome1,
      text: "AVENU",
      description: {
        Srpski:
          "Francuska šansonjerka Dalida bila je osnovna inspiracija i nit od koje je nastala kolekcija Avenue Foch. Estetika njenog odevanja je obojila formu u kojoj se, kroz svaki prikazani odevni komad, istraživao element harmonike i francuskog stila poslednjih dekada XX veka. Raskošna i scenična, ova kolekcija sadrži brojne komade od kože, krzna i šljokica i asocira na zvezdani sjaj Dalide.",
        English:
          "The French chansonniere Dalida was the basic inspiration and thread from which the Avenue Foch collection was created. The aesthetics of her attire has colored a form in which, through every presented item of clothing, the element of harmony was analyzed as well as the French style of the last decade of 20th century. Luxurious and scenic, this collection contains numerous items of leather, fur and embroidery that is associated with the starry glow of Dalida.",
        Italian:
          "La cantante francese Dalida è stata l’ispirazione principale e il filo dal quale è nata la linea Avenue Foch. L’estetica del suo stile ha colorato la forma nella quale, attraverso ogni capo d’abbigliamento mostrato, si ricercava l’elemento della fisarmonica e dello stile francese degli ultimi decenni del XX secolo. Fastosa e spettacolare, questa collezione contiene molti capi in pelle, pellicce e paillettes che ricordano lo splendore stellare di Dalida.",
      },
    },
  ],
  deconstructedUpper: {
    text: "DECONSTR",
    subtitle: "by IGOR TODOROVIĆ",
    photo: decon,
    description: {
      Srpski:
        "Kolekcija je konstruisana dekonstrukcija nove street wear linije u gami modnog potpisa Ateljea „Igor Todorovićˮ. Ovaj koncept osmislili smo za aktivnu, atraktivnu i aktualnu ženu koja u njemu može da pronađe svoj stil, i to na lak i dostupan način, iz sezone u sezonu. Cilj nam je da iz naziva Deconstructed zajedno konstruišemo estetiku u kojoj ćete uživati.",
      English:
        "The collection is constructed deconstruction of the new street wear line in the fashion signature of the Atelier “Igor Todorović”. We have designed this concept for an active, attractive and contemporary woman who can find her style in an easy and accessible way, from season to season. Our aim is to design together, out of the name Deconstructed, an aesthetic in which you will enjoy.",
      Italian:
        'La collezione è una decostruzione costruita della nuova linea street wear che fa parte della gamma dei capi che portano la firma dell’Atelier "Igor Todorovićˮ. Questo concetto è stato ideato per una donna attiva, attraente e attuale che si può riconoscere nello stile della collezione in un modo facile e accessibile, da stagione a stagione. Il nostro scopo è costruire insieme un’estetica dal nome Deconstructed che vi piacerà.',
    },
    video: video,
    deconstructedGalleryTitle: {
      Srpski: "Kolekcija",
      English: "Collection",
      Italian: "collezione",
    },
    photos: {
      2016: [
        {
          image: ii1,
          orientation: "portrait",
        },
        {
          image: ii3,
          orientation: "portrait",
        },
        {
          image: ii10,
          orientation: "landscape",
        },
        {
          image: ii4,
          orientation: "portrait",
        },
        {
          image: ii5,
          orientation: "portrait",
        },
        {
          image: ii11,
          orientation: "landscape",
        },
        {
          image: ii7,
          orientation: "portrait",
        },
        {
          image: ii8,
          orientation: "portrait",
        },
        {
          image: ii12,
          orientation: "landscape",
        },
        {
          image: ii2,
          orientation: "portrait",
        },
        {
          image: ii6,
          orientation: "portrait",
        },
        {
          image: ii13,
          orientation: "landscape",
        },
        {
          image: ii9,
          orientation: "portrait",
        },
        {
          image: ii16,
          orientation: "portrait",
        },
        {
          image: ii14,
          orientation: "landscape",
        },
        {
          image: ii15,
          orientation: "landscape",
        },
        {
          image: ii19,
          orientation: "landscape",
        },
        {
          image: ii18,
          orientation: "landscape",
        },
        {
          image: ii17,
          orientation: "portrait",
        },
      ],
      2017: [
        {
          image: sw1,
          orientation: "portrait",
        },
        {
          image: sw2,
          orientation: "portrait",
        },
        {
          image: sw3,
          orientation: "portrait",
        },
        {
          image: sw4,
          orientation: "portrait",
        },
        {
          image: sw5,
          orientation: "portrait",
        },
        {
          image: sw6,
          orientation: "portrait",
        },
        {
          image: sw7,
          orientation: "portrait",
        },
        {
          image: sw8,
          orientation: "portrait",
        },
        {
          image: sw9,
          orientation: "portrait",
        },
        {
          image: sw10,
          orientation: "portrait",
        },
        {
          image: sw11,
          orientation: "portrait",
        },
        {
          image: sw12,
          orientation: "portrait",
        },
        {
          image: sw13,
          orientation: "portrait",
        },
        {
          image: sw14,
          orientation: "portrait",
        },
        {
          image: sw15,
          orientation: "portrait",
        },
        {
          image: sw16,
          orientation: "portrait",
        },
        {
          image: sw17,
          orientation: "portrait",
        },
        {
          image: sw18,
          orientation: "portrait",
        },
        {
          image: sw19,
          orientation: "portrait",
        },
        {
          image: sw20,
          orientation: "portrait",
        },
      ],
      2018: [
        {
          image: dc18,
          orientation: "portrait",
        },
        {
          image: dc9,
          orientation: "portrait",
        },
        {
          image: dc2,
          orientation: "landscape",
        },
        {
          image: dc5,
          orientation: "portrait",
        },
        {
          image: dc17,
          orientation: "portrait",
        },
        {
          image: dc8,
          orientation: "landscape",
        },
        {
          image: dc14,
          orientation: "portrait",
        },
        {
          image: dc10,
          orientation: "portrait",
        },
        {
          image: dc4,
          orientation: "landscape",
        },
        {
          image: dc16,
          orientation: "portrait",
        },
        {
          image: dc3,
          orientation: "portrait",
        },
        {
          image: dc6,
          orientation: "landscape",
        },
        {
          image: dc7,
          orientation: "portrait",
        },
        {
          image: dc13,
          orientation: "portrait",
        },
        {
          image: dc15,
          orientation: "landscape",
        },
        {
          image: dc12,
          orientation: "landscape",
        },
        {
          image: dc11,
          orientation: "landscape",
        },
        {
          image: dc19,
          orientation: "landscape",
        },
        {
          image: dc1,
          orientation: "portrait",
        },
      ],
    },
  },
  deconstructedLower: {
    description: {
      Srpski: "Prikaži sve",
      English: "Show all",
      Italian: "mostra tutto",
    },
    title: {
      Srpski: "SVI MODELI IZ KOLEKCIJE 2018",
      English: "ALL MODELS FROM THE COLLECTION 2018",
      Italian: "TUTTI I MODELLI DELLA COLLEZIONE 2018",
    },
    images: [
      {
        image: r1,
        desc: "DCS01",
      },
      {
        image: r2,
        desc: "DCS02",
      },
      {
        image: r3,
        desc: "DCS03",
      },
      {
        image: r4,
        desc: "DCS04",
      },
      {
        image: r5,
        desc: "DCS05",
      },
      {
        image: r6,
        desc: "DCS06",
      },
      {
        image: r7,
        desc: "DCS07",
      },
      {
        image: r8,
        desc: "DCS08",
      },
      {
        image: r9,
        desc: "DCS09",
      },
      {
        image: r10,
        desc: "DCS10",
      },
      {
        image: r11,
        desc: "DCS11",
      },
      {
        image: r12,
        desc: "DCS12",
      },
      {
        image: r13,
        desc: "DCS13",
      },
      {
        image: r14,
        desc: "DCS14",
      },
      {
        image: r15,
        desc: "DCS15",
      },
      {
        image: r16,
        desc: "DCS16",
      },
      {
        image: r17,
        desc: "DCS17",
      },
      {
        image: r18,
        desc: "DCS18",
      },
      {
        image: r19,
        desc: "DCS19",
      },
      {
        image: r20,
        desc: "DCS20",
      },
      {
        image: r21,
        desc: "DCS21",
      },
      {
        image: r22,
        desc: "DCS22",
      },
      {
        image: r23,
        desc: "DCS23",
      },
      {
        image: r24,
        desc: "DCS24",
      },
      {
        image: r25,
        desc: "DCS25",
      },
      {
        image: r26,
        desc: "DCS26",
      },
      {
        image: r27,
        desc: "DCS27",
      },
      {
        image: r28,
        desc: "DCS28",
      },
      {
        image: r29,
        desc: "DCS29",
      },
      {
        image: r30,
        desc: "DCS30",
      },
      {
        image: r31,
        desc: "DCS31",
      },
      {
        image: r32,
        desc: "DCS32",
      },
      {
        image: r33,
        desc: "DCS33",
      },
      {
        image: r34,
        desc: "DCS34",
      },
      {
        image: r35,
        desc: "DCS35",
      },
      {
        image: r36,
        desc: "DCS36",
      },
      {
        image: r37,
        desc: "DCS37",
      },
      {
        image: r38,
        desc: "DCS38",
      },
      {
        image: r39,
        desc: "DCS39",
      },
      {
        image: r40,
        desc: "DCS40",
      },
      {
        image: r41,
        desc: "DCS41",
      },
      {
        image: r42,
        desc: "DCS42",
      },
      {
        image: r43,
        desc: "DCS43",
      },
      {
        image: r44,
        desc: "DCS44",
      },
      {
        image: r45,
        desc: "DCS45",
      },
      {
        image: r46,
        desc: "DCS46",
      },
      {
        image: r47,
        desc: "DCS47",
      },
      {
        image: r48,
        desc: "DCS48",
      },
    ],
  },
  news: [
    {
      image: muzejLogo,
      image2: sivepozadine,
      image3: muzejLogo,
      date: "12/12/2018",
      title: "NARODNI MUZEJ",
      subtitle: "OTVARANJE",
      description:
        "Nakon mnogo godina ponovo je otvoren Narodni Muzej u Beogradu. Imali smo privilegiju da dva puta realizujemo reviju i ostvarimo jedno trajno i iskreno prijateljstvo sa ljudima iz Narodnog Muzeja. Cestitamo im ponovo otvaranje i pozivamo vas da posetite to značajno zdanje u centru grada!",
      descriptionfull:
        "Nakon mnogo godina ponovo je otvoren Narodni Muzej u Beogradu. Imali smo privilegiju da dva puta realizujemo reviju i ostvarimo jedno trajno i iskreno prijateljstvo sa ljudima iz Narodnog Muzeja. Cestitamo im ponovo otvaranje i pozivamo vas da posetite to značajno zdanje u centru grada!",
      desc: "Beograd",
      gallery: [
        {
          image: muzej,
          orientation: "portrait",
        },
        {
          image: muzejLogo2,
          orientation: "portrait",
        },
      ],
      bigTitle: "NEWS",
    },
    {
      image: k5,
      image2: sivepozadine,
      image3: k5,
      date: "01/10/2018",
      title: "KINA",
      subtitle: "IZ BACKSTAGE-A",
      desc: "Shangai 2018",
      description:
        "Zahvaljujuci Jeleni Ivanovic i njenoj agenciji MSO, na nedelji visoke mode u Šangaju smo predstavili kolekciju Secret Garden. Hvala jos jednom na prilici da udahnemo duh jedne ogromne i značajne civilizacije. Naši domači gdin  David Lim sa svojim timom priredio nam je inspirativno modno i estetsko iskustvo. Radili smo puno ali i uzivali u lepoti kineske kulture i nasledja. Radujemo se unapred novim prilikama koje su se tamo stvarale i delimo sa vama lepotu Kine van  naše modne prezentacije u kojoj smo uživali.",
      descriptionfull:
        "Zahvaljujuci Jeleni Ivanovic i njenoj agenciji MSO, na nedelji visoke mode u Šangaju smo predstavili kolekciju Secret Garden. Hvala jos jednom na prilici da udahnemo duh jedne ogromne i značajne civilizacije. Naši domači gdin  David Lim sa svojim timom priredio nam je inspirativno modno i estetsko iskustvo. Radili smo puno ali i uzivali u lepoti kineske kulture i nasledja. Radujemo se unapred novim prilikama koje su se tamo stvarale i delimo sa vama lepotu Kine van  naše modne prezentacije u kojoj smo uživali.",
      gallery: [
        {
          image: k,
          orientation: "portrait",
        },
        {
          image: k1,
          orientation: "portrait",
        },
        {
          image: k2,
          orientation: "portrait",
        },
        {
          image: k3,
          orientation: "portrait",
        },
        {
          image: k4,
          orientation: "portrait",
        },
        {
          image: k6,
          orientation: "portrait",
        },
        {
          image: k5,
          orientation: "landscape",
        },
        {
          image: k7,
          orientation: "portrait",
        },
      ],
      bigTitle: "NEWS",
    },
    {
      image: h1,
      image2: sivepozadine,
      image3: h1,
      date: "01/10/2018",
      title: "MALA CRNA HALJINA",
      subtitle: "LBD",
      description:
        "Scenaristički je prvenac glumice Vjere Mujovic i imali smo veliko zadovoljstvo da učestvujemo u izradi odevnih komada za ovaj inspirativan komad u kome bezvremenu Coco Chanel igraju Vjera Mujović i Rada Djuričin. Posebno se zahvaljujemo na saradnji i Evici Milovanov koja je izradila unikatne rukavice sa svojim potpisom, Salonu šešira Ercegovac sa kojim nas spaja visegodišnje prijateljstvo i saradnja koji su za ovu priliku izradili fanastične šešire svojim zanatskim i stilskim umećem.",
      descriptionfull:
        "Scenaristički je prvenac glumice Vjere Mujovic i imali smo veliko zadovoljstvo da učestvujemo u izradi odevnih komada za ovaj inspirativan komad u kome bezvremenu Coco Chanel igraju Vjera Mujović i Rada Djuričin. Posebno se zahvaljujemo na saradnji i Evici Milovanov koja je izradila unikatne rukavice sa svojim potpisom, Salonu šešira Ercegovac sa kojim nas spaja visegodišnje prijateljstvo i saradnja koji su za ovu priliku izradili fanastične šešire svojim zanatskim i stilskim umećem. Zahvaljujemo se  Aleksandru Veljanovicu na scenografiji koju je osmislio, a sve je to rediteljski uobličila Nataša Radulovic. Ceo komad se igra pred 30 ljudi u ikonografskoj kući Beograda Dom Jevrema Grujica. Njihovo gostoprimstvo uvek je posebno i inspirativno, jer ova kuća-muzej je prelepo i važno mesto za uživanje u umetnosti i u razgovorima sa gospodinom Lazarom Šećerovicem i njegovom porodicom. Od ovog oktobra ponovo će se nakon letnjih gostovanja igrati predstava koju vam preporučujemo da je svakako pogledate.",
      desc: "Dom Jevrema Grujića",
      gallery: [
        {
          image: h1,
          orientation: "landscape",
        },
        {
          image: h2,
          orientation: "landscape",
        },
        {
          image: h3,
          orientation: "landscape",
        },
      ],
      bigTitle: "NEWS",
    },
  ],
  newsButton: {
    backToNews: {
      Srpski: "Sve vesti",
      English: "Back to News",
      Italian: "Back to news",
    },
  },
};

export default data;



// WEBPACK FOOTER //
// ./src/data/data.js